{
  "version": "2.0.0",
  "description": "GeoEvent Server to Velocity component mapping matrix",
  "inputs": [
    {
      "geoEventConnector": "esri-in-tcp-text-generictext",
      "geoEventConnectorLabel": "Receive Text from a TCP Socket",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-text-from-a-tcp-socket.htm",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support TCP socket ingestion. Consider using a WebSocket or HTTP-based feed, or an intermediary service to bridge TCP to a supported protocol.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise fully supports TCP Client mode connections. TCP Server mode connections are not yet supported but are on the roadmap.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "TCP Server mode not supported in Velocity for ArcGIS Enterprise (on the roadmap)",
        "Only TCP Client mode is supported in Velocity for ArcGIS Enterprise"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "port",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "Port"
        },
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "host",
          "velocityParamLabel": "Host"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-in-poll-feature-service",
      "geoEventConnectorLabel": "Poll an ArcGIS Server for Features",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/poll-an-arcgis-server-for-features.htm",
      "velocityEquivalent": "feature-layer-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/feature-layer-feed.htm",
      "compatibility": "full",
      "compatibilityNotes": "Feature layer feeds in Velocity provide equivalent polling functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "customLayerUrl",
          "geoEventParamLabel": "Feature Layer URL",
          "velocityParam": "url",
          "velocityParamLabel": "Feature Layer URL"
        },
        {
          "geoEventParam": "refreshInterval",
          "geoEventParamLabel": "Polling Interval (seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "queryDefinition",
          "geoEventParamLabel": "Query Definition",
          "velocityParam": "where",
          "velocityParamLabel": "Where Clause"
        }
      ],
      "alternatives": [],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Verify the Feature Layer URL is accessible from the Velocity environment",
          "manual": true
        },
        {
          "step": 2,
          "action": "If the layer requires authentication, ensure it is shared with the organization or registered as a secured service",
          "manual": true
        },
        {
          "step": 3,
          "action": "Configure polling interval",
          "manual": false,
          "autoValue": "mapped from refreshInterval"
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/feature-layer-feed.html"
    },
    {
      "geoEventConnector": "esri-in-folder-csv",
      "geoEventConnectorLabel": "Watch a Folder for New CSV Files",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/watch-a-folder-for-new-csv-files.htm",
      "velocityEquivalent": "cloud-storage-feed",
      "velocityEquivalentEnterprise": "watch-file",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/amazon-s3.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/watch-a-folder-for-local-files.html",
      "compatibility": "partial",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity for ArcGIS Online uses cloud storage (S3, Azure Blob, etc.) instead of local folders. Files must be uploaded to cloud storage.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports watching a local folder for new files via the Watch File feed type.",
      "limitations": [
        "Local folder paths not supported in Velocity for ArcGIS Online",
        "Requires cloud storage configuration for ArcGIS Online"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "filePattern",
          "velocityParamLabel": "File Pattern"
        }
      ],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "watch-file.fileFilter",
          "velocityParamLabel": "File Filter"
        },
        {
          "geoEventParam": "inputDeleteFiles",
          "geoEventParamLabel": "Delete Files After Processing",
          "velocityParam": "watch-file.deleteFiles",
          "velocityParamLabel": "Delete Files"
        },
        {
          "geoEventParam": "inputBatchFlushIntervalInMS",
          "geoEventParamLabel": "Batch Flush Interval (ms)",
          "velocityParam": "watch-file.watchInterval",
          "velocityParamLabel": "Watch Interval (ms)"
        },
        {
          "geoEventParam": "inputFolderDataStore",
          "geoEventParamLabel": "Folder Data Store",
          "velocityParam": "watch-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-poller",
          "description": "HTTP Poller can fetch CSV files from web-accessible locations",
          "tradeoffs": [
            "Requires files to be web-accessible",
            "Different authentication model"
          ],
          "recommended": false
        }
      ]
    },
    {
      "geoEventConnector": "esri-external-geojson-poll",
      "geoEventConnectorLabel": "Poll an External Website for GeoJSON",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/poll-an-external-website-for-geojson.htm",
      "velocityEquivalent": "http-poller",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/website-poll-feed.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Poller feed in Velocity provides equivalent polling functionality for GeoJSON data from external websites.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/website-poll-feed.html"
    },
    {
      "geoEventConnector": "esri-external-json-poll",
      "geoEventConnectorLabel": "Poll an External Website for JSON",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/poll-an-external-website-for-json.htm",
      "velocityEquivalent": "http-poller",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/website-poll-feed.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Poller feed in Velocity provides equivalent polling functionality for JSON data from external websites.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/website-poll-feed.html"
    },
    {
      "geoEventConnector": "esri-external-xml-poll",
      "geoEventConnectorLabel": "Poll an External Website for XML",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/poll-an-external-website-for-xml.htm",
      "velocityEquivalent": "http-poller",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/website-poll-feed.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Poller feed in Velocity provides equivalent polling functionality for XML data from external websites.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/website-poll-feed.html"
    },
    {
      "geoEventConnector": "esri-receive-features-rest-in",
      "geoEventConnectorLabel": "Receive Features on a REST Endpoint",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-features-on-a-rest-endpoint.htm",
      "velocityEquivalent": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/endpoint-receive-.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Receiver feed in Velocity provides equivalent REST endpoint ingestion.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "REST Endpoint URL",
          "velocityParam": "url",
          "velocityParamLabel": "Endpoint URL"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html"
    },
    {
      "geoEventConnector": "esri-receive-geojson-rest-in",
      "geoEventConnectorLabel": "Receive GeoJSON on a REST Endpoint",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-geojson-on-a-rest-endpoint.htm",
      "velocityEquivalent": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/endpoint-receive-.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Receiver feed in Velocity provides equivalent REST endpoint ingestion for GeoJSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "REST Endpoint URL",
          "velocityParam": "url",
          "velocityParamLabel": "Endpoint URL"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html"
    },
    {
      "geoEventConnector": "esri-receive-json-rest-in",
      "geoEventConnectorLabel": "Receive JSON on a REST Endpoint",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-json-on-a-rest-endpoint.htm",
      "velocityEquivalent": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/endpoint-receive-.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Receiver feed in Velocity provides equivalent REST endpoint ingestion for JSON data. Action required: This component maps to an HTTP Receiver feed in ArcGIS Velocity. When the feed is recreated in Velocity, it will expose a new receiver endpoint URL that is different from the GeoEvent Server REST endpoint URL. Provide the new Velocity endpoint URL to your data provider so they can update the destination where they POST events. This handoff is specific to receiver-style feeds; poller-style feeds generally continue to work from a different machine because Velocity initiates the request.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "REST Endpoint URL",
          "velocityParam": "url",
          "velocityParamLabel": "Endpoint URL"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html"
    },
    {
      "geoEventConnector": "esri-receive-xml-rest-in",
      "geoEventConnectorLabel": "Receive XML on a REST Endpoint",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-xml-on-a-rest-endpoint.htm",
      "velocityEquivalent": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/endpoint-receive-.htm",
      "compatibility": "full",
      "compatibilityNotes": "HTTP Receiver feed in Velocity supports XML as a native feed format. Validate the XML root element, flattening behavior, geometry fields, and date format. Action required: This component maps to an HTTP Receiver feed in ArcGIS Velocity. When the feed is recreated in Velocity, it will expose a new receiver endpoint URL that is different from the GeoEvent Server REST endpoint URL. Provide the new Velocity endpoint URL to your data provider so they can update the destination where they POST events.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "REST Endpoint URL",
          "velocityParam": "url",
          "velocityParamLabel": "Endpoint URL"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "httpMethod",
          "velocityParamLabel": "HTTP Method"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html"
    },
    {
      "geoEventConnector": "esri-in-websocket-geojson-generictext",
      "geoEventConnectorLabel": "Receive/Subscribe GeoJSON on a WebSocket",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-geojson-on-a-websocket.htm",
      "velocityEquivalent": "websocket-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/websocket.htm",
      "compatibility": "full",
      "compatibilityNotes": "WebSocket feed in Velocity provides equivalent WebSocket ingestion for GeoJSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "WebSocket URL",
          "velocityParam": "url",
          "velocityParamLabel": "WebSocket URL"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/websocket.html"
    },
    {
      "geoEventConnector": "esri-in-websocket-json-generictext",
      "geoEventConnectorLabel": "Receive/Subscribe JSON on a WebSocket",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-json-on-a-websocket.htm",
      "velocityEquivalent": "websocket-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/websocket.htm",
      "compatibility": "full",
      "compatibilityNotes": "WebSocket feed in Velocity provides equivalent WebSocket ingestion for JSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "WebSocket URL",
          "velocityParam": "url",
          "velocityParamLabel": "WebSocket URL"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/websocket.html"
    },
    {
      "geoEventConnector": "esri-in-rss",
      "geoEventConnectorLabel": "Receive RSS",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-rss.htm",
      "velocityEquivalent": "rss-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/rss-feed.htm",
      "compatibility": "full",
      "compatibilityNotes": "RSS feed in Velocity provides equivalent RSS ingestion functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "RSS Feed URL",
          "velocityParam": "url",
          "velocityParamLabel": "Feed URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/rss-feed.html"
    },
    {
      "geoEventConnector": "esri-in-udp-text-generictext",
      "geoEventConnectorLabel": "Receive Text from a UDP Socket",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/receive-text-from-a-udp-socket.htm",
      "velocityEquivalent": "",
      "velocityType": "",
      "velocityHelpUrl": "",
      "compatibility": "none",
      "compatibilityNotes": "Velocity does not support UDP ingestion. Consider migrating to a TCP or WebSocket-based feed, or use an intermediary service to bridge UDP to a supported protocol.",
      "limitations": [
        "UDP protocol not supported in Velocity",
        "Requires protocol conversion"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "websocket-feed",
          "description": "Use a WebSocket feed with a UDP-to-WebSocket bridge service",
          "tradeoffs": [
            "Requires intermediary service",
            "Additional infrastructure"
          ],
          "recommended": true
        }
      ]
    },
    {
      "geoEventConnector": "esri-in-kafka-subscribe-geojson",
      "geoEventConnectorLabel": "Subscribe to a Kafka Topic for GeoJSON",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/subscribe-to-a-kafka-topic-for-geojson.htm",
      "velocityEquivalent": "kafka-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka feed in Velocity provides equivalent Kafka topic subscription for GeoJSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        },
        {
          "geoEventParam": "consumerGroupId",
          "geoEventParamLabel": "Consumer Group ID",
          "velocityParam": "consumerGroup",
          "velocityParamLabel": "Consumer Group"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/kafka.html"
    },
    {
      "geoEventConnector": "esri-in-kafka-subscribe-json",
      "geoEventConnectorLabel": "Subscribe to a Kafka Topic for JSON",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/subscribe-to-a-kafka-topic-for-json.htm",
      "velocityEquivalent": "kafka-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka feed in Velocity provides equivalent Kafka topic subscription for JSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/kafka.html"
    },
    {
      "geoEventConnector": "esri-in-kafka-subscribe-text",
      "geoEventConnectorLabel": "Subscribe to a Kafka Topic for Text",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/subscribe-to-a-kafka-topic-for-text.htm",
      "velocityEquivalent": "kafka-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka feed in Velocity supports delimited text data as a native feed format. Validate the delimiter, header row, geometry fields, and date format.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/kafka.html"
    },
    {
      "geoEventConnector": "esri-in-folder-geojson",
      "geoEventConnectorLabel": "Watch a Folder for New GeoJSON Files",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/watch-a-folder-for-new-geojson-files.htm",
      "velocityEquivalent": "cloud-storage-feed",
      "velocityEquivalentEnterprise": "watch-file",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/amazon-s3.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/watch-a-folder-for-local-files.html",
      "compatibility": "partial",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity for ArcGIS Online uses cloud storage (S3, Azure Blob, etc.) instead of local folders. GeoJSON files must be uploaded to cloud storage.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports watching a local folder for new files via the Watch File feed type.",
      "limitations": [
        "Local folder paths not supported in Velocity for ArcGIS Online",
        "Requires cloud storage configuration for ArcGIS Online"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "filePattern",
          "velocityParamLabel": "File Pattern"
        },
        {
          "geoEventParam": "inputFolderDataStore",
          "geoEventParamLabel": "Input Folder",
          "velocityParam": "bucketName",
          "velocityParamLabel": "Bucket/Container Name"
        }
      ],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "watch-file.fileFilter",
          "velocityParamLabel": "File Filter"
        },
        {
          "geoEventParam": "inputDeleteFiles",
          "geoEventParamLabel": "Delete Files After Processing",
          "velocityParam": "watch-file.deleteFiles",
          "velocityParamLabel": "Delete Files"
        },
        {
          "geoEventParam": "inputFolderDataStore",
          "geoEventParamLabel": "Folder Data Store",
          "velocityParam": "watch-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-in-folder-json",
      "geoEventConnectorLabel": "Watch a Folder for New JSON Files",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/ingest/watch-a-folder-for-new-json-files.htm",
      "velocityEquivalent": "cloud-storage-feed",
      "velocityEquivalentEnterprise": "watch-file",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/amazon-s3.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/watch-a-folder-for-local-files.html",
      "compatibility": "partial",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity for ArcGIS Online uses cloud storage (S3, Azure Blob, etc.) instead of local folders. JSON files must be uploaded to cloud storage.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports watching a local folder for new files via the Watch File feed type.",
      "limitations": [
        "Local folder paths not supported in Velocity for ArcGIS Online",
        "Requires cloud storage configuration for ArcGIS Online"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "filePattern",
          "velocityParamLabel": "File Pattern"
        },
        {
          "geoEventParam": "inputFolderDataStore",
          "geoEventParamLabel": "Input Folder",
          "velocityParam": "bucketName",
          "velocityParamLabel": "Bucket/Container Name"
        }
      ],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "inputFileFilter",
          "geoEventParamLabel": "File Filter Pattern",
          "velocityParam": "watch-file.fileFilter",
          "velocityParamLabel": "File Filter"
        },
        {
          "geoEventParam": "inputDeleteFiles",
          "geoEventParamLabel": "Delete Files After Processing",
          "velocityParam": "watch-file.deleteFiles",
          "velocityParamLabel": "Delete Files"
        },
        {
          "geoEventParam": "inputFolderDataStore",
          "geoEventParamLabel": "Folder Data Store",
          "velocityParam": "watch-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "receive-flightaware-connector",
      "geoEventConnectorLabel": "Receive FlightAware Firehose",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "flight-aware-airborne",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/flightaware-airborne-.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/flightaware-airborne-.html",
      "compatibility": "full",
      "compatibilityNotes": "FlightAware Firehose ingestion is fully supported in Velocity via two dedicated feeds. Velocity splits the GeoEvent connector's feedTypeGroup parameter into two separate feeds: flight-aware-airborne (Flight Position, FLIFO, Departure, Arrival, etc.) and flight-aware-surface (Ground Position, Surface Offblock/Onblock). When migrating, choose the Velocity feed that matches the message type group(s) configured on the GeoEvent feedTypeGroup property; create a second feed if both groups are required.",
      "limitations": [
        "GeoEvent supports 20+ message types under a single connector via the feedTypeGroup property; Velocity exposes only two feeds (airborne and surface). Less-common message types (Cancellation, Offblock, Power On, Location Entry/Exit, FMS+Weather, Extended Flight Info, Flight Plan) must be inferred from the feed's payload schema.",
        "Velocity feed authentication is configured via the Velocity item's secrets pane; FlightAware username/password cannot be passed as runtime parameters",
        "PITR (point-in-time recovery) and Range modes are not exposed by Velocity feeds; only Live streaming is supported"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "flightAwareHost",
          "geoEventParamLabel": "FlightAware Firehose Host",
          "velocityParam": "host",
          "velocityParamLabel": "Host"
        },
        {
          "geoEventParam": "portNumber",
          "geoEventParamLabel": "Port Number",
          "velocityParam": "port",
          "velocityParamLabel": "Port"
        },
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Password"
        },
        {
          "geoEventParam": "feedTypeGroup",
          "geoEventParamLabel": "Feed Type Group",
          "velocityParam": "feedType",
          "velocityParamLabel": "Feed Type (Airborne or Surface)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "flight-aware-surface",
          "description": "Pair with the airborne feed when GeoEvent's feedTypeGroup includes Surface/Ground message types (Ground Position, Surface Offblock/Onblock).",
          "tradeoffs": [
            "Requires two Velocity feeds instead of one GeoEvent connector"
          ],
          "recommended": true
        }
      ],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Inspect the GeoEvent connector's feedTypeGroup configuration to identify which message-type groups are required",
          "manual": true
        },
        {
          "step": 2,
          "action": "Create a Velocity flight-aware-airborne feed for airborne message types",
          "manual": false
        },
        {
          "step": 3,
          "action": "Create a Velocity flight-aware-surface feed if surface/ground message types are also required",
          "manual": true
        }
      ],
      "geoEventGalleryItemId": "9a49618c30a54071ab75c69e3f4e6090"
    },
    {
      "geoEventConnector": "geotab-in",
      "geoEventConnectorLabel": "Poll MyGeotab for Device and Log Records",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "geotab",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/geotab.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/geotab.html",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity provides two dedicated Geotab feeds (geotab for live device status, geotab-logrecord for historical log records) covering the GeoEvent geotab-in connector's six GeoEvent Definitions (DeviceStatusInfo, ExceptionEvent, FaultData, LogRecord, StatusData, Trip). Choose the Velocity feed that matches the data feed type configured in MyGeotab; create both feeds when device-status and log-record data are required simultaneously.",
      "limitations": [
        "GeoEvent's single connector emits 6 GeoEvent Definitions; Velocity exposes 2 feeds. Less-common types (ExceptionEvent, FaultData, StatusData, Trip) flow through the most-applicable feed and may need post-processing analytics",
        "MyGeotab database partition and forward-proxy configuration must be replicated in Velocity"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "MyGeotab Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "MyGeotab Password"
        },
        {
          "geoEventParam": "database",
          "geoEventParamLabel": "Database",
          "velocityParam": "database",
          "velocityParamLabel": "Database Partition"
        },
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "Server URL"
        },
        {
          "geoEventParam": "refreshInterval",
          "geoEventParamLabel": "Polling Interval (seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "geotab-logrecord",
          "description": "Pair with the geotab feed when historical GPS log records are also required. Create a second Velocity feed item rather than splitting the GeoEvent connector.",
          "tradeoffs": [
            "Two Velocity feeds map to one GeoEvent connector"
          ],
          "recommended": true
        }
      ],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Determine whether the GeoEvent connector is configured for live device status (DeviceStatusInfo), historical log records (LogRecord), or both",
          "manual": true
        },
        {
          "step": 2,
          "action": "Create a Velocity geotab feed for live device status",
          "manual": false
        },
        {
          "step": 3,
          "action": "Create an additional Velocity geotab-logrecord feed if historical log records are also required",
          "manual": true
        }
      ],
      "geoEventGalleryItemId": "cf02f3b8564042db8de60f582e1ad2a3"
    },
    {
      "geoEventConnector": "esri-in-gtfsrealtime",
      "geoEventConnectorLabel": "Receive GTFS Realtime Feed",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "gtfs",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/gtfs.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/gtfs.html",
      "compatibility": "full",
      "compatibilityNotes": "Velocity's gtfs feed supports the three core GTFS Realtime entity types (Vehicle Positions, Trip Updates, Service Alerts) equivalent to the GeoEvent esri-in-gtfsrealtime connector. ProtoBuf and JSON wire formats are both handled.",
      "limitations": [
        "Velocity polling cadence is configured via the feed item, not as a per-message-type isTextFormat flag",
        "Scheduled-time mode (useScheduledTime/startTime/endTime) is not exposed; Velocity uses simple interval polling"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "sourceURL",
          "geoEventParamLabel": "Source URL",
          "velocityParam": "url",
          "velocityParamLabel": "Feed URL"
        },
        {
          "geoEventParam": "pollingFrequency",
          "geoEventParamLabel": "Polling Frequency",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "headers",
          "geoEventParamLabel": "HTTP Headers",
          "velocityParam": "headers",
          "velocityParamLabel": "HTTP Headers"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "042cfe02783a49d190fc8af72077da12"
    },
    {
      "geoEventConnector": "receive-json-mqtt-in",
      "geoEventConnectorLabel": "Receive JSON from MQTT",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "mqtt-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/mqtt.html",
      "compatibility": "none",
      "compatibilityEnterprise": "partial",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support MQTT broker subscriptions. Use an intermediary service (e.g., Velocity HTTP receiver behind an MQTT-to-HTTP bridge) or migrate to a supported protocol.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports MQTT brokers via the mqtt-feed. Verify QoS, TLS, and authentication options match your GeoEvent configuration; only JSON payload parsing is documented.",
      "limitations": [
        "MQTT not supported in Velocity for ArcGIS Online",
        "Velocity Enterprise MQTT does not expose retain-message handling separately from QoS",
        "Topic hierarchies and wildcard subscriptions (+, #) follow MQTT spec; verify in Velocity Enterprise"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "brokerUrl",
          "velocityParamLabel": "Broker URL"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        },
        {
          "geoEventParam": "qosLevel",
          "geoEventParamLabel": "MQTT QoS Level",
          "velocityParam": "qos",
          "velocityParamLabel": "Quality of Service"
        },
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Password"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "If MQTT migration to Velocity is not feasible, deploy an MQTT-to-HTTP bridge that forwards messages to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Requires additional infrastructure (bridge service)",
            "Loses MQTT-native QoS and retained-message semantics"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "6e77d82d05cb47919ccf299457831f81"
    },
    {
      "geoEventConnector": "rabbitmq-text-in",
      "geoEventConnectorLabel": "Receive Text from RabbitMQ",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "rabbitmq",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/rabbitmq.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/rabbitmq.html",
      "compatibility": "full",
      "compatibilityNotes": "Velocity's rabbitmq feed equivalents the GeoEvent rabbitmq-text-in connector for AMQP 0-9-1 brokers. Map exchange/queue settings and TLS configuration verbatim.",
      "limitations": [
        "Velocity's RabbitMQ feed is text-based; for non-text payloads use a custom Field Calculator or a Generic JSON post-processor",
        "Exchange-binding configuration in Velocity is simpler than GeoEvent; mid-stream rebindings are not supported"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "host",
          "velocityParamLabel": "Broker Host"
        },
        {
          "geoEventParam": "port",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "Broker Port"
        },
        {
          "geoEventParam": "virtualHost",
          "geoEventParamLabel": "Virtual Host",
          "velocityParam": "vhost",
          "velocityParamLabel": "Virtual Host"
        },
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Password"
        },
        {
          "geoEventParam": "exchangeName",
          "geoEventParamLabel": "Exchange Name",
          "velocityParam": "exchange",
          "velocityParamLabel": "Exchange"
        },
        {
          "geoEventParam": "queueName",
          "geoEventParamLabel": "Queue Name",
          "velocityParam": "queue",
          "velocityParamLabel": "Queue"
        },
        {
          "geoEventParam": "routingKey",
          "geoEventParamLabel": "Routing Key",
          "velocityParam": "routingKey",
          "velocityParamLabel": "Routing Key"
        },
        {
          "geoEventParam": "ssl",
          "geoEventParamLabel": "Use SSL",
          "velocityParam": "ssl",
          "velocityParamLabel": "Use TLS"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "b1da75d6f2874c7ba31ef15c6da2e86b"
    },
    {
      "geoEventConnector": "verizonconnect-in",
      "geoEventConnectorLabel": "Receive Verizon Connect Reveal GPS Push",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "verizon-reveal-2",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/verizon-connect-reveal.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/verizon-connect-reveal.html",
      "compatibility": "full",
      "compatibilityNotes": "Velocity's verizon-reveal-2 feed is a hosted equivalent of the GeoEvent verizonconnect-in connector. Velocity manages the HTTPS push endpoint internally, eliminating the IIS+HTTPS proxy requirement of the GeoEvent connector.",
      "limitations": [
        "Velocity hosts the push endpoint; existing Verizon webhook URLs must be reconfigured to the Velocity-provided URL",
        "Metadata refresh interval is fixed in Velocity; not user-configurable like metaDataUpdateInterval"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Reveal API Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Reveal API Password"
        },
        {
          "geoEventParam": "customerName",
          "geoEventParamLabel": "Customer Name",
          "velocityParam": "customerName",
          "velocityParamLabel": "Reveal Customer Name"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "0d8393e22b2d4a92a3f98f4308ed117a"
    },
    {
      "geoEventConnector": "receive-waze-connector",
      "geoEventConnectorLabel": "Receive Waze for Cities Data",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "waze",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/waze.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/waze.html",
      "compatibility": "full",
      "compatibilityNotes": "Velocity's waze feed handles the same Waze for Cities data feed URL pattern as the GeoEvent receive-waze-connector. Both alerts and traffic data types are supported.",
      "limitations": [
        "Hierarchical WazeAlert/WazeJam schemas in GeoEvent flatten differently in Velocity; downstream feature service writes may require schema mapping"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "Waze Data Feed URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "dataTypes",
          "geoEventParamLabel": "Data Types",
          "velocityParam": "dataTypes",
          "velocityParamLabel": "Data Types"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "db18d2068d1d410595b841c3df38c280"
    },
    {
      "geoEventConnector": "Networkfleet",
      "geoEventConnectorLabel": "Receive Networkfleet on a REST Endpoint",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not provide a dedicated Networkfleet feed. The GeoEvent Networkfleet connector accepts pushed Networkcar XML data; you can replicate the endpoint with a Velocity HTTP receiver feed plus a custom XML parser in a downstream analytic.",
      "compatibilityNotesEnterprise": "Velocity has no Networkfleet connector. Velocity Enterprise's HTTP Receiver feed (Endpoint - Receive) can accept the pushed Networkcar XML payload, but the XML-to-feature parser and the nine Networkfleet GeoEvent Definitions (NetworkfleetGPS, NetworkfleetDiagnostic, NetworkfleetHistogram, etc.) are not available in Velocity and are impractical to reproduce as a downstream analytic. Use an external bridge that decodes Networkcar XML and posts JSON to a Velocity HTTP receiver.",
      "limitations": [
        "No dedicated Networkfleet adapter in Velocity; Networkcar XML must be parsed by an analytic",
        "9+ GeoEvent Definitions (NetworkfleetGPS, NetworkfleetDiagnostic, NetworkfleetHistogram, etc.) must be reconstructed manually as Velocity output schemas",
        "External proxy/firewall configuration carries over from the GeoEvent deployment"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "acceptableMimeTypes",
          "geoEventParamLabel": "Acceptable MIME Types",
          "velocityParam": "contentType",
          "velocityParamLabel": "Content Type"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "720c28f0ef72426792012d10c37a251a"
    },
    {
      "geoEventConnector": "ais_tcp",
      "geoEventConnectorLabel": "Receive AIS from a TCP Socket",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support TCP ingestion or AIS-specific decoding. Use an intermediary AIS-to-HTTP bridge that decodes NMEA-0183HS AIS payloads to JSON or GeoJSON and posts to a Velocity HTTP receiver.",
      "compatibilityNotesEnterprise": "Velocity has no AIS connector. Velocity Enterprise's TCP (Client) feed can receive the raw NMEA-0183HS byte stream, but the AIS message decoder (parsing !AIVDM/!AIVDO sentences into AisPosition, AisVesselStatic, AisAidsToNavigationReport messages, NMEA checksum validation, multi-sentence reassembly, and bit-level field extraction) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external AIS decoder service (or the GeoEvent AIS connector itself) that posts decoded JSON to a Velocity HTTP receiver.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "AIS message decoding is not built into Velocity; you must add a parser analytic for NMEA-0183HS",
        "MMSI/IMO/MessageTypeID/spatial filtering must be implemented as Velocity analytics filters"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "host",
          "velocityParamLabel": "Host"
        },
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "Port"
        },
        {
          "geoEventParam": "mode",
          "geoEventParamLabel": "Connection Mode",
          "velocityParam": "mode",
          "velocityParamLabel": "Connection Mode (Client only)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Pair the GeoEvent AIS connector or a standalone AIS decoder service with a Velocity HTTP receiver. The decoder posts AIS messages as JSON.",
          "tradeoffs": [
            "Requires running a separate decoder service",
            "Higher latency than direct TCP ingestion"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "24770812a22e4feba56555aeafbf68ac"
    },
    {
      "geoEventConnector": "http-cap-in",
      "geoEventConnectorLabel": "Poll an External Website for CAP Items",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "rss-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/rss-feed.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/rss-feed.html",
      "compatibility": "none",
      "compatibilityNotes": "Velocity has no Common Alerting Protocol connector. Velocity's RSS feed can poll the same RSS/Atom CAP distribution endpoints, but the CAP-XML decoder (severity, certainty, urgency, alert footprint polygons, area circles, geocode handling) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external CAP decoder that posts decoded JSON to a Velocity HTTP receiver, or continue running the GeoEvent http-cap-in connector in place.",
      "limitations": [
        "Velocity does not have a dedicated CAP adapter; CAP XML must be parsed by an analytic",
        "CAP polygon area decoding (alert footprints) must be reconstructed in a Field Calculator analytic",
        "Long-polling mode is not supported in Velocity"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "Feed URL"
        },
        {
          "geoEventParam": "frequency",
          "geoEventParamLabel": "Frequency (in seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "acceptableMimeTypes",
          "geoEventParamLabel": "Acceptable MIME Types",
          "velocityParam": "contentType",
          "velocityParamLabel": "Content Type"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-poller",
          "description": "Use the HTTP Poller feed if the CAP source is a direct XML endpoint (not RSS/Atom wrapped).",
          "tradeoffs": [
            "No automatic CAP XML decoding"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "0f5c9403458c46a3b3329c10f572378c"
    },
    {
      "geoEventConnector": "cityworks-in",
      "geoEventConnectorLabel": "Poll External Cityworks for Work Orders",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not have a dedicated Cityworks feed. The GeoEvent cityworks-in connector polls the Cityworks REST API and emits typed work-order GeoEvents. A Velocity HTTP Poller feed can replicate the polling, but token-based Cityworks authentication and work-order template filtering must be implemented in a custom Field Calculator analytic.",
      "compatibilityNotesEnterprise": "Velocity has no Cityworks connector and no dedicated HTTP polling feed. Velocity's polling story is the Website Poll feed, which retrieves a single URL on an interval, but the Cityworks-specific integration (Bearer token authentication flow, work-order template ID filtering, dynamic-work-order field mapping, response pagination) must be hand-built and is impractical to reproduce in production. Use an external Cityworks bridge that posts decoded JSON to a Velocity HTTP receiver, or continue running the GeoEvent cityworks-in connector in place.",
      "limitations": [
        "No dedicated Cityworks adapter in Velocity",
        "Cityworks token-based authentication must be configured manually in HTTP headers",
        "Work-order template ID filtering must be reimplemented as a Velocity filter analytic"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "Cityworks REST Endpoint URL"
        },
        {
          "geoEventParam": "refreshInterval",
          "geoEventParamLabel": "Polling Interval (seconds)",
          "velocityParam": "interval",
          "velocityParamLabel": "Polling Interval"
        },
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Cityworks Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Cityworks Password"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "04ed0b57fff24d728406e13e21bd5962"
    },
    {
      "geoEventConnector": "esri-receive-taip-udp",
      "geoEventConnectorLabel": "Receive TAIP from a UDP Socket",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support UDP ingestion or Trimble TAIP message decoding. Use an intermediary UDP-to-HTTP bridge that decodes TAIP messages (0xF0/F1/F2/RAM) and posts JSON to a Velocity HTTP receiver.",
      "compatibilityNotesEnterprise": "Velocity has no Trimble TAIP connector and no UDP feed. The GeoEvent connector decodes the binary TAIP message formats (RPV/RCP/RLN/RAM) automatically, but Velocity (Online and Enterprise) does not support UDP ingestion at all and has no TAIP decoder. Use an external TAIP decoder service that posts decoded JSON to a Velocity HTTP receiver.",
      "limitations": [
        "UDP not supported in Velocity for ArcGIS Online",
        "TAIP message decoding is not built into Velocity",
        "TAIP TM Time/Date messages are not supported even in GeoEvent"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "UDP Port"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Decode TAIP messages externally and post as JSON to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Requires running a separate decoder service"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "8513241a8c9445339d108185642f7af9"
    },
    {
      "geoEventConnector": "esri-receive-taip-tcp",
      "geoEventConnectorLabel": "Receive TAIP from a TCP Socket",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support TCP ingestion. Use an intermediary TCP-to-HTTP bridge with a TAIP decoder. Velocity Enterprise's tcp-feed (Client mode only) can receive raw TAIP messages but does not decode them.",
      "compatibilityNotesEnterprise": "Velocity has no Trimble TAIP connector. Velocity Enterprise's TCP (Client) feed can receive raw bytes on a TCP socket (client mode only), but the binary TAIP message decoder (RPV/RCP/RLN/RAM message formats, byte-level field extraction, checksum validation) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external TAIP decoder service that posts decoded JSON to a Velocity HTTP receiver.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "TCP Server mode not supported in Velocity Enterprise (Client mode only)",
        "TAIP decoding must be reimplemented in an analytic"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "TCP Port"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Decode TAIP messages externally and post as JSON to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Requires running a separate decoder service"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "8513241a8c9445339d108185642f7af9"
    },
    {
      "geoEventConnector": "receive-cot-http-in",
      "geoEventConnectorLabel": "Receive Cursor on Target Over HTTP",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "http-receiver-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/endpoint-receive-.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/endpoint-receive.html",
      "compatibility": "none",
      "compatibilityNotes": "Velocity has no Cursor on Target connector. Velocity's HTTP Receiver feed (Endpoint - Receive) can accept the raw CoT XML payload, but the CoT XSD parser (event/point/detail elements, time stamps, affiliations, custom XSD support) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external CoT decoder that posts JSON to a Velocity HTTP receiver, or continue running the GeoEvent CoT connector in place.",
      "limitations": [
        "No dedicated CoT XML decoder in Velocity; XSD-based parsing must be reimplemented",
        "Custom XSDs (XSD_Path extensibility) are not supported in Velocity"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "acceptableMimeTypes",
          "geoEventParamLabel": "Acceptable MIME Types",
          "velocityParam": "contentType",
          "velocityParamLabel": "Content Type"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-poller",
          "description": "If the CoT source is a polled endpoint rather than a push endpoint, use the HTTP Poller feed instead.",
          "tradeoffs": [
            "Polling latency vs. push latency"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "067feaad95964bc5889d6f44f774b370",
      "compatibilityEnterprise": "none"
    },
    {
      "geoEventConnector": "receive-cot-tcp-in",
      "geoEventConnectorLabel": "Receive Cursor on Target Over TCP Socket",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support TCP ingestion. Velocity Enterprise's tcp-feed (Client mode only) can receive raw CoT-XML messages but does not decode them against the CoT XSD; implement parsing in a downstream analytic.",
      "compatibilityNotesEnterprise": "Velocity has no Cursor on Target connector. Velocity Enterprise's TCP (Client) feed can receive raw CoT XML bytes (client mode only), but the CoT XSD schema parser is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external CoT decoder that posts JSON to a Velocity HTTP receiver.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "TCP Server mode not supported in Velocity Enterprise",
        "CoT XML parsing must be reimplemented"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "TCP Port"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Bridge CoT TCP to HTTP for Velocity ArcGIS Online compatibility.",
          "tradeoffs": [
            "Requires running a separate bridge service"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "067feaad95964bc5889d6f44f774b370"
    },
    {
      "geoEventConnector": "activemq-text-in-user-created",
      "geoEventConnectorLabel": "Receive Text from ActiveMQ (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "ActiveMQ is not a built-in GeoEvent connector; users construct an input by pairing the ActiveMQ Inbound Transport (JMS/AMQP) with a Text/JSON/GeoJSON Adapter on the GeoEvent site. Velocity does not currently offer an ActiveMQ feed. Recommended migration paths: (1) reconfigure publishers to send to Kafka or MQTT (both supported by Velocity Enterprise), or (2) deploy an ActiveMQ-to-HTTP bridge that posts messages to a Velocity HTTP receiver feed.",
      "limitations": [
        "No native ActiveMQ feed in Velocity (Online or Enterprise)",
        "JMS Queue vs. Topic semantics must be re-mapped to Kafka topics or MQTT topics",
        "Broker authentication, TLS, and message selectors must be reconfigured on the new broker"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "kafka-feed",
          "description": "If publishers can be reconfigured, migrate ActiveMQ topics to Kafka topics for native Velocity Enterprise ingestion.",
          "tradeoffs": [
            "Requires publisher-side changes",
            "Different broker semantics (Kafka log vs. JMS queue/topic)"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "mqtt-feed",
          "description": "Alternatively, migrate to an MQTT broker for Velocity Enterprise mqtt-feed compatibility.",
          "tradeoffs": [
            "MQTT QoS model differs from JMS persistence",
            "No transactional message handling"
          ],
          "recommended": false
        },
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Deploy an ActiveMQ-to-HTTP bridge service that forwards messages as JSON to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Requires running a separate bridge service",
            "No native JMS acknowledgment semantics"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "40507af01cb5437196ee27064479aa38"
    },
    {
      "geoEventConnector": "geomessage-udp-in-user-created",
      "geoEventConnectorLabel": "Receive GeoMessage over UDP (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "GeoMessage is not a built-in GeoEvent connector; users pair the GeoMessage Adapter (inbound) with a UDP Inbound Transport on the GeoEvent site. Velocity for ArcGIS Online does not support UDP ingestion. Velocity Enterprise's udp-feed can receive raw GeoMessage XML, but parsing the 8+ military message types (trackrep, spotrep, eod, medevac, sitrep, slantrep, bedavail, chemlight) requires a custom analytic.",
      "compatibilityNotesEnterprise": "Velocity has no GeoMessage connector and no UDP feed. The GeoEvent assembly (GeoMessage adapter + UDP inbound transport) decodes the eight military message types (trackrep, spotrep, eod, medevac, sitrep, slantrep, bedavail, chemlight) automatically, but Velocity (Online and Enterprise) does not support UDP ingestion at all and has no GeoMessage XML parser. Use an external GeoMessage decoder that posts decoded JSON to a Velocity HTTP receiver.",
      "limitations": [
        "UDP not supported in Velocity for ArcGIS Online",
        "GeoMessage XML schema (Esri military) is not natively decoded",
        "Used by Dynamic Situational Awareness App; consumers may require schema-compatible re-encoding"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "port",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "UDP Port"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Bridge GeoMessage UDP to a Velocity HTTP receiver via an external relay.",
          "tradeoffs": [
            "Requires running a separate bridge service"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "cd3ce7a01fdc46a48aa199bfd091dd50"
    },
    {
      "geoEventConnector": "receive-tweets-user-created",
      "geoEventConnectorLabel": "Receive Tweets (user-created, deprecated gallery)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "The Twitter (now X) gallery connector is in the GeoEvent deprecated category and requires user assembly (Twitter Transport + Twitter Adapter). The legacy Twitter Public Streaming API (statuses/filter) is no longer accessible to most accounts; X's v2 API requires a paid tier. Velocity does not provide a Twitter feed. Migration recommendation: replace social-media monitoring workflows with a third-party aggregator that pushes to a Velocity HTTP receiver.",
      "limitations": [
        "Twitter/X API access is restricted by paid tier (Basic/Pro/Enterprise)",
        "No native Velocity Twitter feed (Online or Enterprise)",
        "Tweet schema (TweetStatus) is hierarchical and would require Field Mapper logic in Velocity"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Use a third-party social-media aggregator service that pushes filtered tweets as JSON to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Vendor dependency",
            "Cost of aggregator subscription on top of X API costs"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "cf5509c1f3d94364b264be0518423a5b",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "receive-instagram-feed-user-created",
      "geoEventConnectorLabel": "Receive Instagram Feed (user-created, deprecated gallery)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "The Instagram gallery connector is in the deprecated category and was originally built against the legacy Instagram API (sandbox mode, OAuth 2.0 user-permissions). Instagram's Graph API replacement no longer supports the original user-media endpoints used by the connector. Velocity does not provide an Instagram feed. Migration is not viable without a third-party aggregator.",
      "limitations": [
        "Original Instagram API is deprecated; Graph API replacement requires Meta business verification",
        "No native Velocity Instagram feed",
        "30 requests/hour rate limit on legacy API; Graph API differs"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Use a third-party Instagram aggregator that pushes posts to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Vendor dependency"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "d55d760440d94710aa7d45eda4107c76",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "receive-rap-tcp-user-created",
      "geoEventConnectorLabel": "Receive Sierra Wireless RAP from a TCP Socket (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Sierra Wireless RAP (Remote Access Protocol) is a user-assembled connector pairing the RAP Adapter with TCP or UDP transports. RAP messages are binary (0x11/0x12/0x13/0x14 = Standard GPS, UTC Date, UTC+RF, UTC+RF+EIO). Velocity Enterprise's tcp-feed can ingest the raw stream, but RAP binary decoding must be reimplemented in a downstream analytic.",
      "compatibilityNotesEnterprise": "Velocity has no Sierra Wireless RAP connector. Velocity Enterprise's TCP (Client) feed can receive raw RAP bytes on a TCP socket, but the binary RAP message decoder (0x11/0x12/0x13/0x14 = Standard GPS, UTC Date, UTC+RF, UTC+RF+EIO formats; byte-level field extraction) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external RAP decoder that posts decoded JSON to a Velocity HTTP receiver. RAP is typically broadcast via cellular UDP rather than TCP; see the UDP variant for the more common case.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "RAP binary message decoding must be reimplemented",
        "SNF (Store and Forward) is not supported even in the GeoEvent connector"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "TCP Port"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "086bc14060a44c599b166d4f3767acb4",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "receive-rap-udp-user-created",
      "geoEventConnectorLabel": "Receive Sierra Wireless RAP from a UDP Socket (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Primary Sierra Wireless RAP transport (cellular broadcast). Velocity Enterprise's udp-feed accepts raw RAP messages; binary decoding (0x11/0x12/0x13/0x14 formats) must be reimplemented as a Velocity analytic.",
      "compatibilityNotesEnterprise": "Velocity has no Sierra Wireless RAP connector and no UDP feed. The GeoEvent assembly (RAP adapter + UDP inbound transport) decodes the binary RAP message formats (0x11/0x12/0x13/0x14) automatically, but Velocity (Online and Enterprise) does not support UDP ingestion at all and has no RAP decoder. Use an external RAP decoder that posts decoded JSON to a Velocity HTTP receiver.",
      "limitations": [
        "UDP not supported in Velocity for ArcGIS Online",
        "RAP binary message decoding must be reimplemented",
        "ACE Manager device provisioning carries over from existing deployment"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "UDP Port"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "086bc14060a44c599b166d4f3767acb4",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "receive-nmea-tcp-user-created",
      "geoEventConnectorLabel": "Receive NMEA from a TCP Socket (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp-feed",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/tcp-client-f.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "NMEA-0183 is a user-assembled connector pairing the NMEA Adapter with a TCP transport. Velocity Enterprise's tcp-feed can receive raw NMEA ASCII messages; sentence parsing (GPGGA, GPGLL, GPRMC, GPGSA, GPVTG) must be reimplemented as a Velocity analytic.",
      "compatibilityNotesEnterprise": "Velocity has no NMEA connector. Velocity Enterprise's TCP (Client) feed can receive raw NMEA-0183 ASCII bytes, but the NMEA sentence parser (GPGGA, GPGLL, GPRMC, GPGSA, GPVTG and related sentence types, checksum validation, multi-sentence reassembly) is not available in Velocity and is impractical to reproduce as a downstream analytic. Use an external NMEA decoder that posts decoded JSON to a Velocity HTTP receiver. NMEA-0183HS (used by AIS) is not supported even by the GeoEvent connector.",
      "limitations": [
        "TCP not supported in Velocity for ArcGIS Online",
        "TCP Server mode not supported in Velocity Enterprise",
        "NMEA sentence parsing must be reimplemented",
        "5+ sentence types must each be handled (GPGGA, GPGLL, GPRMC, GPGSA, GPVTG)"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "serverPort",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "TCP Port"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "6704a8df6d1e48448b8471768428215c",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "flextext-in-placeholder",
      "geoEventConnectorLabel": "FlexText Inbound Adapter (Tier 3 placeholder)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "FlexText is referenced in the GeoEvent migration guide set but does not appear in the 34 gallery PDFs we have. It is possibly a confusion with the regexText adapter (which IS gallery-shipped). Treated here as a Tier 3 placeholder until the FlexText component identity is confirmed against a live install.",
      "limitations": [
        "Component identity unconfirmed; entry to be revised when FlexText is verified",
        "If FlexText is in fact regexText, see the separate regexText adapter entry"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "regexText-adapter",
          "description": "If 'FlexText' refers to the regexText adapter, use that entry instead. The regexText adapter extends the Text Adapter with Java regex matching for complex delimiters.",
          "tradeoffs": [
            "Requires confirming component identity"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItem": true
    },
    {
      "geoEventConnector": "ng911-ali-ani-in",
      "geoEventConnectorLabel": "Receive NG9-1-1 ALI/ANI Data (Tier 3 custom)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "feed",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "NG9-1-1 ALI/ANI integration is a Tier 3 (custom/gRPC middleware) workflow. There is no shipped GeoEvent gallery connector and no Velocity equivalent feed. Integration typically requires a NENA-i3-compliant gateway service that translates SIP/RTP+ALI/ANI data into JSON over HTTP for downstream ingestion. Recommended path: build a NENA gateway service that posts NG9-1-1 events to a Velocity HTTP receiver feed.",
      "limitations": [
        "No shipped connector; requires custom integration",
        "NENA-i3 SIP/RTP protocol stack must be implemented externally",
        "ALI/ANI data is jurisdiction-specific; schema varies by ECC"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-receiver-feed",
          "description": "Deploy a NENA-i3 gateway service that posts ALI/ANI events as JSON to a Velocity HTTP receiver.",
          "tradeoffs": [
            "Requires custom NENA-i3 gateway service",
            "Compliance with NENA standards is the integrator's responsibility"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "kafka-feed",
          "description": "For high-volume PSAP deployments, route NENA gateway output via Kafka topics for resilient ingestion.",
          "tradeoffs": [
            "Additional infrastructure (Kafka cluster)"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItem": true
    }
  ],
  "outputs": [
    {
      "geoEventConnector": "esri-out-json-fs-update",
      "geoEventConnectorLabel": "Update a Feature",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/update-a-feature.htm",
      "velocityEquivalent": "feature-layer-new-output",
      "velocityEquivalentInPlace": "feature-layer-existing-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-new-.htm",
      "velocityHelpUrlInPlace": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-existing-.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/feature-layer-new-.html",
      "compatibility": "full",
      "compatibilityNotes": "A Feature Layer output (new or existing) in Velocity provides equivalent functionality for updating features: set the Data Storage Method to 'Keep only latest feature for each Track ID value' so Velocity maintains a single current feature per Track ID rather than appending every event.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "serviceLayerUrl",
          "geoEventParamLabel": "Service Layer URL",
          "velocityParam": "featureLayerName",
          "velocityParamLabel": "Feature Layer Name"
        },
        {
          "geoEventParam": "uniqueFeatureIdentifier",
          "geoEventParamLabel": "Unique Feature Identifier Field",
          "velocityParam": "dataStorageMethod",
          "velocityParamLabel": "Data Storage Method (Keep only latest feature for each Track ID value)"
        },
        {
          "geoEventParam": "updateInterval",
          "geoEventParamLabel": "Update Interval (seconds)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages write intervals internally)"
        },
        {
          "geoEventParam": "deleteOldFeatures",
          "geoEventParamLabel": "Delete Old Features",
          "velocityParam": "dataRetention",
          "velocityParamLabel": "Data Retention (time period for retaining data)"
        },
        {
          "geoEventParam": "maxFeaturesPerTransaction",
          "geoEventParamLabel": "Maximum Features Per Transaction",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages batch sizes internally)"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-out-json-fs-add",
      "geoEventConnectorLabel": "Add a Feature",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/add-a-feature.htm",
      "velocityEquivalent": "feature-layer-new-output",
      "velocityEquivalentInPlace": "feature-layer-existing-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-new-.htm",
      "velocityHelpUrlInPlace": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-existing-.htm",
      "compatibility": "full",
      "compatibilityNotes": "Feature Layer output in Velocity provides equivalent functionality for adding features.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "serviceLayerUrl",
          "geoEventParamLabel": "Service Layer URL",
          "velocityParam": "featureLayerName",
          "velocityParamLabel": "Feature Layer Name"
        },
        {
          "geoEventParam": "updateInterval",
          "geoEventParamLabel": "Update Interval (seconds)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages write intervals internally)"
        },
        {
          "geoEventParam": "maxFeaturesPerTransaction",
          "geoEventParamLabel": "Maximum Features Per Transaction",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages batch sizes internally)"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/feature-layer-new-.html"
    },
    {
      "geoEventConnector": "esri-out-csv-file-log",
      "geoEventConnectorLabel": "Write to a CSV File",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-to-a-csv-file.htm",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "write-file",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/write-to-local-file.html",
      "compatibility": "none",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity Online does not support direct local CSV file output. Treat this component as unmapped; file-based outputs must be redesigned for an Online-compatible destination.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports this GeoEvent output with the Write to Local File output using the Delimited format. Verify that the target file directory exists on the Velocity machine and is writable by the Velocity service account.",
      "limitations": [
        "No direct CSV file output in Velocity Online",
        "No equivalent file-based output in Velocity Online"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "outputFolderDataStore",
          "geoEventParamLabel": "Output Folder Data Store",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputDirectory",
          "geoEventParamLabel": "Output Directory",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputBaseFileName",
          "geoEventParamLabel": "Output Base File Name",
          "velocityParam": "write-file.fileNamePrefix",
          "velocityParamLabel": "Filename Prefix"
        },
        {
          "geoEventParam": "outputFileExtension",
          "geoEventParamLabel": "Output File Extension",
          "velocityParam": "write-file.fileExtension",
          "velocityParamLabel": "File Extension"
        },
        {
          "geoEventParam": "outputFileSizeLimitMethod",
          "geoEventParamLabel": "Output File Size Limit Method",
          "velocityParam": "write-file.rolloverMethod",
          "velocityParamLabel": "File Rollover Method"
        },
        {
          "geoEventParam": "outputFileSizeLimitValue",
          "geoEventParamLabel": "Output File Size Limit Value",
          "velocityParam": "write-file.rolloverSize",
          "velocityParamLabel": "File Rollover Size"
        },
        {
          "geoEventParam": "outputFileFrequency",
          "geoEventParamLabel": "Output File Frequency",
          "velocityParam": "write-file.rolloverFrequency",
          "velocityParamLabel": "File Rollover Frequency"
        },
        {
          "geoEventParam": "AttributeSeparator",
          "geoEventParamLabel": "Attribute Separator",
          "velocityParam": "delimited.fieldDelimiter",
          "velocityParamLabel": "Field Delimiter"
        },
        {
          "geoEventParam": "MessageSeparator",
          "geoEventParamLabel": "Message Separator",
          "velocityParam": "delimited.messageDelimiter",
          "velocityParamLabel": "Message Delimiter"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-out-feature-stream-service",
      "geoEventConnectorLabel": "Send Features to a Stream Service",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/send-features-to-a-stream-service.htm",
      "velocityEquivalent": "stream-layer-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/stream-layer.htm",
      "compatibility": "full",
      "compatibilityNotes": "Stream Layer output in Velocity provides equivalent real-time streaming output.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "streamServiceUrl",
          "geoEventParamLabel": "Stream Service URL",
          "velocityParam": "streamLayerName",
          "velocityParamLabel": "Stream Layer Name"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/stream-layer.html"
    },
    {
      "geoEventConnector": "esri-out-json-bds-update",
      "geoEventConnectorLabel": "Update a Feature in a Spatiotemporal Big Data Store",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/update-a-feature-in-a-spatiotemporal-big-data-store.htm",
      "velocityEquivalent": "feature-layer-new-output",
      "velocityEquivalentInPlace": "feature-layer-existing-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-new-.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Feature Layer output in Velocity supports spatiotemporal storage and retention/export policy settings, but GeoEvent spatiotemporal big data store operational controls do not migrate directly. Validate the Velocity-managed storage mode, retention/export policy, Track ID/update behavior, and schema.",
      "limitations": [
        "Replication factor and shard count controls are not exposed in Velocity outputs",
        "Write intervals, transaction sizing, and write concurrency are managed by Velocity",
        "Retention and export policy settings require validation against the original GeoEvent archiving intent"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "serviceLayerUrl",
          "geoEventParamLabel": "Service Layer URL",
          "velocityParam": "featureLayerName",
          "velocityParamLabel": "Feature Layer Name"
        },
        {
          "geoEventParam": "uniqueFeatureIdentifier",
          "geoEventParamLabel": "Unique Feature Identifier Field",
          "velocityParam": "dataStorageMethod",
          "velocityParamLabel": "Data Storage Method (Keep only latest feature for each Track ID value)"
        },
        {
          "geoEventParam": "dataRetention",
          "geoEventParamLabel": "Data Retention",
          "velocityParam": "dataRetention",
          "velocityParamLabel": "Data Retention (time period for retaining data)"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/feature-layer-new-.html"
    },
    {
      "geoEventConnector": "esri-out-message-email-send",
      "geoEventConnectorLabel": "Send an Email",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/send-an-email.htm",
      "velocityEquivalent": "email-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/email.htm",
      "compatibility": "full",
      "compatibilityNotes": "Email output in Velocity provides equivalent email notification functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "smtpHost",
          "geoEventParamLabel": "SMTP Host",
          "velocityParam": "smtpServer",
          "velocityParamLabel": "SMTP Server"
        },
        {
          "geoEventParam": "smtpPort",
          "geoEventParamLabel": "SMTP Port",
          "velocityParam": "port",
          "velocityParamLabel": "Port"
        },
        {
          "geoEventParam": "to",
          "geoEventParamLabel": "To",
          "velocityParam": "recipients",
          "velocityParamLabel": "Recipients"
        },
        {
          "geoEventParam": "subject",
          "geoEventParamLabel": "Subject",
          "velocityParam": "subject",
          "velocityParamLabel": "Subject"
        },
        {
          "geoEventParam": "body",
          "geoEventParamLabel": "Body",
          "velocityParam": "body",
          "velocityParamLabel": "Body"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/email.html"
    },
    {
      "geoEventConnector": "esri-out-message-sms-send",
      "geoEventConnectorLabel": "Send a Text Message",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/send-a-text-message.htm",
      "velocityEquivalent": "text-message-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/text-message.htm",
      "compatibility": "full",
      "compatibilityNotes": "Text Message output in Velocity provides equivalent SMS notification functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "phoneNumber",
          "geoEventParamLabel": "Phone Number",
          "velocityParam": "phoneNumber",
          "velocityParamLabel": "Phone Number"
        },
        {
          "geoEventParam": "message",
          "geoEventParamLabel": "Message",
          "velocityParam": "message",
          "velocityParamLabel": "Message"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/text-message.html"
    },
    {
      "geoEventConnector": "esri-out-message-xmpp-send",
      "geoEventConnectorLabel": "Send an Instant Message",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/send-an-instant-message.htm",
      "velocityEquivalent": "",
      "velocityType": "",
      "velocityHelpUrl": "",
      "compatibility": "none",
      "compatibilityNotes": "Velocity does not support XMPP instant messaging output. Consider using Email or Text Message outputs as alternatives for notifications.",
      "limitations": [
        "XMPP protocol not supported in Velocity"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "email-output",
          "description": "Use Email output for notification delivery",
          "tradeoffs": [
            "Different delivery mechanism",
            "Not real-time instant messaging"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "text-message-output",
          "description": "Use Text Message output for mobile notifications",
          "tradeoffs": [
            "SMS instead of XMPP",
            "Requires phone numbers"
          ],
          "recommended": false
        }
      ]
    },
    {
      "geoEventConnector": "esri-out-kafka-publish-geojson",
      "geoEventConnectorLabel": "Write GeoJSON to a Kafka Topic",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-geojson-to-a-kafka-topic.htm",
      "velocityEquivalent": "kafka-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka output in Velocity provides equivalent Kafka topic publishing for GeoJSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/kafka.html"
    },
    {
      "geoEventConnector": "esri-out-kafka-publish-json",
      "geoEventConnectorLabel": "Write JSON to a Kafka Topic",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-json-to-a-kafka-topic.htm",
      "velocityEquivalent": "kafka-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka output in Velocity provides equivalent Kafka topic publishing for JSON data.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/kafka.html"
    },
    {
      "geoEventConnector": "esri-out-kafka-publish-text",
      "geoEventConnectorLabel": "Write Text to a Kafka Topic",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-text-to-a-kafka-topic.htm",
      "velocityEquivalent": "kafka-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/kafka.htm",
      "compatibility": "full",
      "compatibilityNotes": "Kafka output in Velocity supports Delimited as a native output data format. Validate the field delimiter, record terminator, and header behavior.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bootstrapServers",
          "geoEventParamLabel": "Bootstrap Servers",
          "velocityParam": "brokers",
          "velocityParamLabel": "Brokers"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/kafka.html"
    },
    {
      "geoEventConnector": "esri-out-geojson-file-log",
      "geoEventConnectorLabel": "Write to a GeoJSON File",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-to-a-geojson-file.htm",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "write-file",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/write-to-local-file.html",
      "compatibility": "none",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity Online does not support direct local GeoJSON file output. Treat this component as unmapped; file-based outputs must be redesigned for an Online-compatible destination.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports this GeoEvent output with the Write to Local File output using the GeoJSON format. Verify that the target file directory exists on the Velocity machine and is writable by the Velocity service account.",
      "limitations": [
        "No direct GeoJSON file output in Velocity Online",
        "No equivalent file-based output in Velocity Online"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "outputFolderDataStore",
          "geoEventParamLabel": "Output Folder Data Store",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputDirectory",
          "geoEventParamLabel": "Output Directory",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputBaseFileName",
          "geoEventParamLabel": "Output Base File Name",
          "velocityParam": "write-file.fileNamePrefix",
          "velocityParamLabel": "Filename Prefix"
        },
        {
          "geoEventParam": "outputFileExtension",
          "geoEventParamLabel": "Output File Extension",
          "velocityParam": "write-file.fileExtension",
          "velocityParamLabel": "File Extension"
        },
        {
          "geoEventParam": "outputFileSizeLimitMethod",
          "geoEventParamLabel": "Output File Size Limit Method",
          "velocityParam": "write-file.rolloverMethod",
          "velocityParamLabel": "File Rollover Method"
        },
        {
          "geoEventParam": "outputFileSizeLimitValue",
          "geoEventParamLabel": "Output File Size Limit Value",
          "velocityParam": "write-file.rolloverSize",
          "velocityParamLabel": "File Rollover Size"
        },
        {
          "geoEventParam": "outputFileFrequency",
          "geoEventParamLabel": "Output File Frequency",
          "velocityParam": "write-file.rolloverFrequency",
          "velocityParamLabel": "File Rollover Frequency"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-out-json-file-log",
      "geoEventConnectorLabel": "Write to a JSON File",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/write-to-a-json-file.htm",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "write-file",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/write-to-local-file.html",
      "compatibility": "none",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity Online does not support direct local JSON file output. Treat this component as unmapped; file-based outputs must be redesigned for an Online-compatible destination.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports this GeoEvent output with the Write to Local File output using the JSON format. Verify that the target file directory exists on the Velocity machine and is writable by the Velocity service account.",
      "limitations": [
        "No direct JSON file output in Velocity Online",
        "No equivalent file-based output in Velocity Online"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "outputFolderDataStore",
          "geoEventParamLabel": "Output Folder Data Store",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputDirectory",
          "geoEventParamLabel": "Output Directory",
          "velocityParam": "write-file.fileDirectory",
          "velocityParamLabel": "File Directory"
        },
        {
          "geoEventParam": "outputBaseFileName",
          "geoEventParamLabel": "Output Base File Name",
          "velocityParam": "write-file.fileNamePrefix",
          "velocityParamLabel": "Filename Prefix"
        },
        {
          "geoEventParam": "outputFileExtension",
          "geoEventParamLabel": "Output File Extension",
          "velocityParam": "write-file.fileExtension",
          "velocityParamLabel": "File Extension"
        },
        {
          "geoEventParam": "outputFileSizeLimitMethod",
          "geoEventParamLabel": "Output File Size Limit Method",
          "velocityParam": "write-file.rolloverMethod",
          "velocityParamLabel": "File Rollover Method"
        },
        {
          "geoEventParam": "outputFileSizeLimitValue",
          "geoEventParamLabel": "Output File Size Limit Value",
          "velocityParam": "write-file.rolloverSize",
          "velocityParamLabel": "File Rollover Size"
        },
        {
          "geoEventParam": "outputFileFrequency",
          "geoEventParamLabel": "Output File Frequency",
          "velocityParam": "write-file.rolloverFrequency",
          "velocityParamLabel": "File Rollover Frequency"
        },
        {
          "geoEventParam": "outputFileHeader",
          "geoEventParamLabel": "Output File Header",
          "velocityParam": "write-file.fileHeader",
          "velocityParamLabel": "File Header"
        },
        {
          "geoEventParam": "outputFileFooter",
          "geoEventParamLabel": "Output File Footer",
          "velocityParam": "write-file.fileFooter",
          "velocityParamLabel": "File Footer"
        }
      ],
      "alternatives": []
    },
    {
      "geoEventConnector": "esri-out-text-tcp-client",
      "geoEventConnectorLabel": "Push Text to an External TCP Socket",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/push-text-to-an-external-tcp-socket.htm",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "tcp",
      "velocityType": "",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/tcp-client-o.html",
      "compatibility": "none",
      "compatibilityEnterprise": "partial",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support direct TCP Client output. Use a supported output or an intermediary service to bridge to TCP.",
      "compatibilityNotesEnterprise": "Velocity for ArcGIS Enterprise supports TCP Client output, but the migration requires validating the remote host, port, client connection timeout, delimiter, and record terminator against the destination socket protocol.",
      "limitations": [
        "No direct TCP Client output is available in Velocity for ArcGIS Online",
        "Velocity for ArcGIS Enterprise TCP Client output requires socket framing validation"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "tcp.host",
          "velocityParamLabel": "Host"
        },
        {
          "geoEventParam": "port",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "tcp.port",
          "velocityParamLabel": "Port"
        },
        {
          "geoEventParam": "clientConnectionTimeout",
          "geoEventParamLabel": "Client Connection Timeout (seconds)",
          "velocityParam": "tcp.clientConnectionTimeout",
          "velocityParamLabel": "Client Connection Timeout"
        },
        {
          "geoEventParam": "AttributeSeparator",
          "geoEventParamLabel": "Attribute Separator",
          "velocityParam": "delimited.fieldDelimiter",
          "velocityParamLabel": "Field Delimiter"
        },
        {
          "geoEventParam": "MessageSeparator",
          "geoEventParamLabel": "Message Separator",
          "velocityParam": "delimited.recordTerminator",
          "velocityParamLabel": "Record Terminator"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "feature-layer-new-output",
          "description": "Write events to a hosted feature layer and consume via downstream TCP service",
          "tradeoffs": [
            "Requires intermediary service for TCP delivery",
            "Not real-time TCP push"
          ],
          "recommended": false
        }
      ]
    },
    {
      "geoEventConnector": "esri-json-http-external-out",
      "geoEventConnectorLabel": "Push JSON to an External Website",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/disseminate-and-notify/push-json-to-an-external-website.htm",
      "velocityEquivalent": "http-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/endpoint.htm",
      "compatibility": "full",
      "compatibilityNotes": "Velocity HTTP output supports JSON payloads, POST/PUT/DELETE methods, application/json content type, custom headers, URL parameters, and HTTP authentication. Validate Arcade POST body expressions, sample values, and endpoint rate limits.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "clientURL",
          "geoEventParamLabel": "External Website URL",
          "velocityParam": "http-output.url",
          "velocityParamLabel": "URL"
        },
        {
          "geoEventParam": "httpMethod",
          "geoEventParamLabel": "HTTP Method",
          "velocityParam": "http-output.httpMethod",
          "velocityParamLabel": "HTTP Method"
        },
        {
          "geoEventParam": "postContentType",
          "geoEventParamLabel": "Post Content Type",
          "velocityParam": "http-output.contentType",
          "velocityParamLabel": "Content Type"
        },
        {
          "geoEventParam": "headers",
          "geoEventParamLabel": "Headers",
          "velocityParam": "http-output.headers",
          "velocityParamLabel": "Headers"
        },
        {
          "geoEventParam": "clientParameters",
          "geoEventParamLabel": "Client Parameters",
          "velocityParam": "http-output.urlParameters",
          "velocityParamLabel": "URL Parameters"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/endpoint.html"
    },
    {
      "geoEventConnector": "push-json-mqtt-out",
      "geoEventConnectorLabel": "Push JSON to MQTT",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support MQTT publishing. Bridge via an HTTP receiver downstream that forwards to MQTT externally.",
      "compatibilityNotesEnterprise": "Velocity Enterprise has no MQTT output. The MQTT feed exists for ingest (subscribing to a broker) but publishing JSON to MQTT is not available. Use a Velocity HTTP/Endpoint output to send to an external bridge that re-publishes to MQTT, or continue running the GeoEvent push-json-mqtt-out connector in place.",
      "limitations": [
        "MQTT publishing not supported in Velocity for ArcGIS Online",
        "Retained-message flag handled separately from QoS in Velocity Enterprise"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "brokerUrl",
          "velocityParamLabel": "Broker URL"
        },
        {
          "geoEventParam": "topic",
          "geoEventParamLabel": "Topic",
          "velocityParam": "topic",
          "velocityParamLabel": "Topic"
        },
        {
          "geoEventParam": "qosLevel",
          "geoEventParamLabel": "MQTT QoS Level",
          "velocityParam": "qos",
          "velocityParamLabel": "Quality of Service"
        },
        {
          "geoEventParam": "retainMessages",
          "geoEventParamLabel": "Retain Messages",
          "velocityParam": "retain",
          "velocityParamLabel": "Retain Messages"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "6e77d82d05cb47919ccf299457831f81"
    },
    {
      "geoEventConnector": "rabbitmq-text-out",
      "geoEventConnectorLabel": "Publish Text to RabbitMQ",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "rabbitmq-output",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/rabbitmq.html",
      "compatibility": "none",
      "compatibilityEnterprise": "full",
      "compatibilityNotes": "Velocity for ArcGIS Online does not support RabbitMQ publishing. Use an HTTP receiver bridge that forwards to RabbitMQ externally.",
      "compatibilityNotesEnterprise": "Velocity Enterprise's rabbitmq-output equivalents the GeoEvent rabbitmq-text-out connector. Map exchange/queue settings and TLS configuration directly.",
      "limitations": [
        "RabbitMQ publishing not supported in Velocity for ArcGIS Online",
        "Mid-stream re-binding to different exchanges is not supported"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "host",
          "geoEventParamLabel": "Server Host",
          "velocityParam": "host",
          "velocityParamLabel": "Broker Host"
        },
        {
          "geoEventParam": "port",
          "geoEventParamLabel": "Server Port",
          "velocityParam": "port",
          "velocityParamLabel": "Broker Port"
        },
        {
          "geoEventParam": "virtualHost",
          "geoEventParamLabel": "Virtual Host",
          "velocityParam": "vhost",
          "velocityParamLabel": "Virtual Host"
        },
        {
          "geoEventParam": "exchangeName",
          "geoEventParamLabel": "Exchange Name",
          "velocityParam": "exchange",
          "velocityParamLabel": "Exchange"
        },
        {
          "geoEventParam": "queueName",
          "geoEventParamLabel": "Queue Name",
          "velocityParam": "queue",
          "velocityParamLabel": "Queue"
        },
        {
          "geoEventParam": "routingKey",
          "geoEventParamLabel": "Routing Key",
          "velocityParam": "routingKey",
          "velocityParamLabel": "Routing Key"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "b1da75d6f2874c7ba31ef15c6da2e86b"
    },
    {
      "geoEventConnector": "esri-out-json-fs-add-nonnull",
      "geoEventConnectorLabel": "Add a Feature Omitting Null/Empty Fields",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "feature-layer-new-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-new-.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/feature-layer-new-.html",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity's standard Feature Layer (New) output always writes whatever the analytic emits. The GeoEvent 'Non-Null' variant intentionally drops null and empty fields from the feature write to preserve existing values; replicate this in Velocity by adding a Field Calculator analytic that strips null/empty fields before writing.",
      "limitations": [
        "Velocity does not have a 'non-null' write mode; field filtering must be implemented in a preceding analytic",
        "Write null vs. write empty-string distinction must be modeled in the analytic"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "arcgisServerConnection",
          "geoEventParamLabel": "ArcGIS Server Connection",
          "velocityParam": "featureLayerName",
          "velocityParamLabel": "Feature Layer Name"
        },
        {
          "geoEventParam": "serviceName",
          "geoEventParamLabel": "Service Name",
          "velocityParam": "featureLayerName",
          "velocityParamLabel": "Feature Layer Name"
        },
        {
          "geoEventParam": "writeNullValues",
          "geoEventParamLabel": "Write Null Values",
          "velocityParam": "",
          "velocityParamLabel": "N/A (implement via Field Calculator analytic)"
        },
        {
          "geoEventParam": "writeEmptyStringValues",
          "geoEventParamLabel": "Write Empty String Values",
          "velocityParam": "",
          "velocityParamLabel": "N/A (implement via Field Calculator analytic)"
        },
        {
          "geoEventParam": "updateInterval",
          "geoEventParamLabel": "Update Interval (seconds)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages write intervals internally)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "feature-layer-existing-output",
          "description": "If the goal is to preserve existing values during update, use Velocity's existing-feature output with a Field Calculator analytic that drops null/empty fields.",
          "tradeoffs": [
            "Requires analytic-side null/empty filtering"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "389a554f729342139b0428771ee5fd3a"
    },
    {
      "geoEventConnector": "esri-out-json-fs-update-nonnull",
      "geoEventConnectorLabel": "Update a Feature Omitting Null/Empty Fields",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "feature-layer-existing-output",
      "velocityType": "output",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/feature-layer-existing-.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/feature-layer-existing-.html",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity's existing-feature output overwrites field values per the inbound event payload. The GeoEvent Non-Null Update variant intentionally drops null/empty fields so existing feature values are preserved when source data is intermittent. Replicate in Velocity by adding a Field Calculator analytic that strips null/empty fields before the update output.",
      "limitations": [
        "Velocity has no native 'non-null' update mode; field filtering must be in a preceding analytic",
        "Unique feature identifier handling matches the standard Update connector"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "uniqueFeatureIdentifierField",
          "geoEventParamLabel": "Unique Feature Identifier Field",
          "velocityParam": "trackIdField",
          "velocityParamLabel": "Track ID Field"
        },
        {
          "geoEventParam": "writeNullValues",
          "geoEventParamLabel": "Write Null Values",
          "velocityParam": "",
          "velocityParamLabel": "N/A (implement via Field Calculator analytic)"
        },
        {
          "geoEventParam": "writeEmptyStringValues",
          "geoEventParamLabel": "Write Empty String Values",
          "velocityParam": "",
          "velocityParamLabel": "N/A (implement via Field Calculator analytic)"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "389a554f729342139b0428771ee5fd3a"
    },
    {
      "geoEventConnector": "cityworks-out",
      "geoEventConnectorLabel": "Send Work Order Requests to an External Cityworks Website",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "http-output",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/endpoint.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity does not have a dedicated Cityworks output. The GeoEvent cityworks-out connector POSTs structured work-order requests to the Cityworks REST API. A Velocity http-output can replicate the POST, but work-order template ID handling, dynamic-work-order field mapping, and Cityworks authentication must be implemented in upstream analytics.",
      "compatibilityNotesEnterprise": "Velocity has no Cityworks output. Velocity Enterprise's Endpoint output can POST to the Cityworks REST API, but the Cityworks-specific request construction (work-order template selection, dynamic-work-order field mapping, Bearer token authentication, Configuration Complete handling) must be hand-built and is impractical to reproduce in production. Continue running the GeoEvent cityworks-out connector in place or build an external Cityworks adapter.",
      "limitations": [
        "No dedicated Cityworks adapter in Velocity",
        "Work-order template caching and Configuration Complete flag are not supported",
        "Dynamic Work Order template ID lookup must be implemented as a Velocity analytic"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "url",
          "geoEventParamLabel": "URL",
          "velocityParam": "url",
          "velocityParamLabel": "Cityworks REST Endpoint URL"
        },
        {
          "geoEventParam": "username",
          "geoEventParamLabel": "Username",
          "velocityParam": "username",
          "velocityParamLabel": "Cityworks Username"
        },
        {
          "geoEventParam": "password",
          "geoEventParamLabel": "Password",
          "velocityParam": "password",
          "velocityParamLabel": "Cityworks Password"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "04ed0b57fff24d728406e13e21bd5962"
    },
    {
      "geoEventConnector": "send-cot-tcp-out",
      "geoEventConnectorLabel": "Send Cursor on Target message over TCP Squirt",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity does not provide a TCP output (in either Online or Enterprise). The GeoEvent CoT 'Squirt' TCP outbound publishes Cursor-on-Target XML messages to a TCP socket. Migration requires either: (1) deploying a TCP-to-HTTP bridge that listens for Velocity http-output and forwards to the CoT consumer, or (2) running the existing GeoEvent CoT connector in-place alongside Velocity for output-only operations.",
      "limitations": [
        "No TCP output support in Velocity (Online or Enterprise)",
        "CoT XML schema generation must be reimplemented as a Velocity Field Calculator analytic",
        "Custom XSD support not available"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-output",
          "description": "Deploy a CoT-XML-aware bridge service that accepts Velocity http-output JSON and emits CoT TCP Squirt to consumers.",
          "tradeoffs": [
            "Requires running a separate bridge service",
            "CoT XML schema construction must be implemented in the bridge"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "067feaad95964bc5889d6f44f774b370"
    },
    {
      "geoEventConnector": "activemq-text-out-user-created",
      "geoEventConnectorLabel": "Publish Text to ActiveMQ (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "ActiveMQ output is user-assembled (ActiveMQ Outbound Transport + Text/JSON/GeoJSON Adapter). Velocity has no ActiveMQ output. Migration options: (1) republish to Kafka or MQTT (both supported by Velocity Enterprise outputs), or (2) bridge Velocity http-output to ActiveMQ via an external relay.",
      "limitations": [
        "No native ActiveMQ output in Velocity",
        "JMS Queue/Topic semantics must be re-mapped to Kafka/MQTT or HTTP",
        "Transactional message handling not supported"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "kafka-output",
          "description": "If consumers can be reconfigured, publish to Kafka topics for native Velocity Enterprise output.",
          "tradeoffs": [
            "Requires consumer-side changes"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "http-output",
          "description": "Deploy an HTTP-to-ActiveMQ bridge service that receives Velocity http-output POSTs and republishes to ActiveMQ.",
          "tradeoffs": [
            "Requires running a separate bridge service"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "40507af01cb5437196ee27064479aa38"
    },
    {
      "geoEventConnector": "geomessage-file-out-user-created",
      "geoEventConnectorLabel": "Write GeoMessage to File (user-created)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "azure-blob-output",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/azure-blob-store.html",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "GeoMessage file output is user-assembled (GeoMessage Adapter outbound + File Transport). Velocity has no native local file writer. Velocity Enterprise's cloud-storage outputs (Azure Blob, S3, etc.) can persist GeoMessage XML if the XML serialization is constructed in a preceding analytic. Used primarily by the Dynamic Situational Awareness App.",
      "compatibilityNotesEnterprise": "Velocity has no GeoMessage output and no local file writer. Velocity Enterprise's cloud-storage outputs (Azure Blob Store, Amazon S3) can persist arbitrary text, but the GeoMessage XML serializer (selecting message type via the _type field and emitting valid XML for the eight military message types - trackrep, spotrep, eod, medevac, sitrep, slantrep, bedavail, chemlight) is not available in Velocity and is impractical to reproduce as a downstream analytic. Continue running the GeoEvent GeoMessage outbound connector in place, or build an external GeoMessage serializer.",
      "limitations": [
        "No local file writer in Velocity",
        "GeoMessage XML serialization must be reimplemented as an analytic",
        "8+ message types (trackrep, spotrep, eod, medevac, sitrep, slantrep, bedavail, chemlight) must be handled per-type"
      ],
      "parameterMappings": [],
      "parameterMappingsEnterprise": [
        {
          "geoEventParam": "geoMessageType",
          "geoEventParamLabel": "GeoMessage Type",
          "velocityParam": "",
          "velocityParamLabel": "N/A (handled in analytic via _type field)"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "cd3ce7a01fdc46a48aa199bfd091dd50"
    },
    {
      "geoEventConnector": "mongodb-json-out-user-created",
      "geoEventConnectorLabel": "Write JSON documents to MongoDB (user-created, legacy 10.2)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "MongoDB output is a legacy GeoEvent Processor 10.2 sample (Aug 2013) and requires manual JAR installation plus a user-assembled connector (MongoDB Transport + JSON Adapter). Velocity has no MongoDB output. Migration paths: (1) deploy an HTTP-to-MongoDB bridge that accepts Velocity http-output JSON and writes via the MongoDB driver, or (2) route via Kafka where Kafka Connect MongoDB Sink can consume.",
      "limitations": [
        "Legacy GeoEvent Processor 10.2 era — likely not in active use",
        "MongoDB driver 2.11.1 required by the original connector is now ancient",
        "No native MongoDB output in Velocity"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-output",
          "description": "Deploy an HTTP-to-MongoDB bridge service.",
          "tradeoffs": [
            "Requires running a separate bridge service"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "kafka-output",
          "description": "Publish to Kafka and use Kafka Connect MongoDB Sink to land documents.",
          "tradeoffs": [
            "Additional infrastructure (Kafka + Kafka Connect)"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "0f246f7e9f074b3f80b24724b460e82f",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "hadoop-csv-out-user-created",
      "geoEventConnectorLabel": "Write CSV to Hadoop HDFS (user-created, legacy 10.2)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Hadoop HDFS output is a legacy GeoEvent Processor 10.2 sample (Aug 2013) with no Kerberos authentication. Velocity has no HDFS output. Modern data-lake migration paths: (1) use Velocity Enterprise cloud-storage outputs (S3, Azure Blob) which most data-lake platforms ingest natively, or (2) deploy an HTTP-to-HDFS bridge service.",
      "limitations": [
        "Legacy GeoEvent Processor 10.2 era",
        "No Kerberos authentication in the original connector",
        "No native HDFS output in Velocity"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "azure-blob-output",
          "description": "Modern data-lake replacement: write to Azure Blob / S3 / GCS, which most analytics platforms ingest natively.",
          "tradeoffs": [
            "Cloud-storage egress costs",
            "Different file-finalization semantics"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "fa7b33b480c940019d17d3eb159a8b04",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "send-tweet-user-created",
      "geoEventConnectorLabel": "Send Tweet (user-created, deprecated gallery)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Twitter/X output is in the deprecated gallery category and uses legacy OAuth credentials. Velocity has no Twitter output. Current X API tiers (Basic/Pro/Enterprise) charge for posting access. Migration is generally not advised; recommend retiring social-media posting workflows or replacing with a third-party scheduling service.",
      "limitations": [
        "X API posting access is restricted to paid tiers",
        "OAuth 1.0a credentials must be rotated periodically",
        "No native Velocity Twitter output"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "http-output",
          "description": "Use a third-party social-media posting service (Buffer, Hootsuite, etc.) reachable via HTTP webhook.",
          "tradeoffs": [
            "Vendor dependency",
            "Subscription cost"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "cf5509c1f3d94364b264be0518423a5b",
      "geoEventGalleryItemDeprecated": true
    },
    {
      "geoEventConnector": "flextext-out-placeholder",
      "geoEventConnectorLabel": "FlexText Outbound Adapter (Tier 3 placeholder)",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "output",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "FlexText is referenced in the GeoEvent migration guide set but does not appear in the 34 gallery PDFs we have. Treated here as a Tier 3 placeholder until the FlexText component identity is confirmed. If it refers to the regexText adapter, that adapter is inbound-only and there is no outbound variant.",
      "limitations": [
        "Component identity unconfirmed",
        "regexText adapter (the likely intended component) is inbound-only; no outbound counterpart exists"
      ],
      "parameterMappings": [],
      "alternatives": [],
      "geoEventGalleryItem": true
    }
  ],
  "processors": [
    {
      "geoEventProcessor": "com.esri.ges.processor/Choice",
      "geoEventProcessorLabel": "Choice",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/choices.htm",
      "velocityEquivalent": "route-by-expressions",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/route-by-expressions.htm",
      "compatibility": "partial",
      "compatibilityNotes": "GeoEvent choice elements map to the Velocity Route by Expressions tool, which routes each record against ordered Arcade expressions top-to-bottom (first match wins), exactly like the choice's serial if/else evaluation. The migration auto-converts each 'when' condition to an Arcade route expression and maps the 'otherwise' clause to the tool's native Otherwise output (so unmatched records are routed rather than dropped). It is reported as partially compatible because the auto-generated route expressions should be verified against the original conditions, Route by Expressions allows at most 10 routes, and any condition the converter cannot translate confidently (for example spatial or regular-expression matching) needs manual attention. For simple attribute comparisons like the ones in a basic choice, this is typically a low-effort import-and-verify step rather than a rewrite.",
      "limitations": [
        "Route by Expressions supports a maximum of 10 routes; choice elements with more when-clauses must be split across multiple tools",
        "The 'when' conditions are auto-converted to Arcade route expressions and should be verified against the originals; conditions the converter cannot translate confidently (spatial, regular-expression, or custom logic) require manual attention",
        "Route ordering (first match wins) and the Otherwise output should be confirmed to match the source choice's intended routing"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "when",
          "geoEventParamLabel": "When (conditional statement)",
          "velocityParam": "expression",
          "velocityParamLabel": "Expression (Arcade)"
        },
        {
          "geoEventParam": "otherwise",
          "geoEventParamLabel": "Otherwise",
          "velocityParam": "otherwise",
          "velocityParamLabel": "Otherwise"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/route-by-expressions.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/Buffer-Creator",
      "geoEventProcessorLabel": "Buffer Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/buffer-creator-processor.htm",
      "velocityEquivalent": "buffer-creator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/create-buffers.htm",
      "compatibility": "full",
      "compatibilityNotes": "Create Buffers tool in Velocity provides equivalent functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bufferDistance",
          "geoEventParamLabel": "Buffer Distance",
          "velocityParam": "distance",
          "velocityParamLabel": "Distance"
        },
        {
          "geoEventParam": "unit",
          "geoEventParamLabel": "Distance Unit",
          "velocityParam": "unit",
          "velocityParamLabel": "Unit"
        },
        {
          "geoEventParam": "bufferwkid",
          "geoEventParamLabel": "Buffer Spatial Reference",
          "velocityParam": "spatialReference",
          "velocityParamLabel": "Spatial Reference"
        }
      ],
      "alternatives": [],
      "arcadeAlternative": {
        "functions": ["Buffer", "BufferGeodetic"],
        "note": "The dedicated Create Buffers tool is the recommended equivalent; Calculate Field with the ArcGIS Arcade Buffer() or BufferGeodetic() geometry function can also create buffer geometries."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/create-buffers.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/GeoTagger",
      "geoEventProcessorLabel": "GeoTagger",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/geotagger-processor.htm",
      "velocityEquivalent": "join-features",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "compatibility": "partial",
      "compatibilityNotes": "The GeoTagger processor is best mapped to the Join Features tool in Velocity, configured with a spatial join condition. The geofence data source used in GeoEvent Server must be configured as a Feature Layer data source in the Velocity real-time analytic. The Join Features tool supports spatial join operations (e.g., intersects) that replicate the GeoTagger's spatial tagging behavior. When the GeoTagger is configured with DelimitedValue output and followed by a Field Splitter, use Join Features with a One-to-Many spatial join to produce individual events per intersection.",
      "limitations": [
        "Geofence data must be available as a Feature Layer data source in the Velocity analytic",
        "GeoEvent geofence category/path references (e.g., 'CommandCenterPolys/.*') must be replaced with a Feature Layer source",
        "DelimitedValue output mode is replaced by configuring a One-to-Many spatial join"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geofence",
          "geoEventParamLabel": "Geofence",
          "velocityParam": "joinSource",
          "velocityParamLabel": "Join Source (Feature Layer data source)"
        },
        {
          "geoEventParam": "spatialOperator",
          "geoEventParamLabel": "Spatial Operator",
          "velocityParam": "spatialRelationship",
          "velocityParamLabel": "Spatial Relationship"
        },
        {
          "geoEventParam": "geometryFieldName",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "geometryField",
          "velocityParamLabel": "Geometry Field"
        }
      ],
      "alternatives": [],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Publish GeoEvent geofence data as a hosted Feature Layer in ArcGIS Online or Enterprise",
          "manual": true
        },
        {
          "step": 2,
          "action": "Add the Feature Layer as a data source in the Velocity real-time analytic",
          "manual": true
        },
        {
          "step": 3,
          "action": "Configure Join Features tool with spatial join condition (e.g., intersects)",
          "manual": true
        },
        {
          "step": 4,
          "action": "If GeoTagger used DelimitedValue output with a Field Splitter, configure a One-to-Many spatial join instead",
          "manual": true
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/join-features.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/AddXYZProcessor",
      "geoEventProcessorLabel": "Add XYZ Processor",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/add-xyz-values-processor.htm",
      "velocityEquivalent": "add-xyz-values",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/add-xyz-values.htm",
      "compatibility": "full",
      "compatibilityNotes": "Add XYZ Values is a dedicated tool in Velocity. Z coordinate field configuration is only supported when the input schema contains a z field.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "geometryField",
          "velocityParamLabel": "Geometry Field (implicit from input schema)"
        },
        {
          "geoEventParam": "xField",
          "geoEventParamLabel": "X-Field",
          "velocityParam": "xCoordinateFieldName",
          "velocityParamLabel": "X Coordinate Field Name"
        },
        {
          "geoEventParam": "yField",
          "geoEventParamLabel": "Y-Field",
          "velocityParam": "yCoordinateFieldName",
          "velocityParamLabel": "Y Coordinate Field Name"
        },
        {
          "geoEventParam": "zField",
          "geoEventParamLabel": "Z-Field",
          "velocityParam": "zCoordinateFieldName",
          "velocityParamLabel": "Z Coordinate Field Name"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/add-xyz-values.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldCalculator",
      "geoEventProcessorLabel": "Field Calculator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-calculator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Calculate Field tool in Velocity provides equivalent functionality. GeoEvent Server expressions must be rewritten as ArcGIS Arcade expressions.",
      "limitations": [
        "GeoEvent Server expressions are not compatible with Velocity and must be rewritten as ArcGIS Arcade expressions"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "expression",
          "geoEventParamLabel": "Expression",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression"
        },
        {
          "geoEventParam": "existingFieldName",
          "geoEventParamLabel": "Existing Field Name",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name"
        },
        {
          "geoEventParam": "resultDestination",
          "geoEventParamLabel": "Result Destination",
          "velocityParam": "resultDestination",
          "velocityParamLabel": "Result Destination"
        }
      ],
      "alternatives": [],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Rewrite GeoEvent Server expression as an ArcGIS Arcade expression. Refer to the Velocity Arcade profile (https://developers.arcgis.com/arcade/profiles/velocity/) and the Arcade guide for Velocity (https://doc.arcgis.com/en/iot/analyze/use-arcade-expressions.htm) for supported functions and syntax",
          "manual": true
        },
        {
          "step": 2,
          "action": "Test the Arcade expression using the built-in expression builder or the Arcade Playground (https://developers.arcgis.com/arcade/playground/). Ensure null values are handled explicitly — Arcade treats nulls as 0 in math operations",
          "manual": true
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldMapper",
      "geoEventProcessorLabel": "Field Mapper",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-mapper-processor.htm",
      "velocityEquivalent": "field-mapper",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/map-fields.htm",
      "compatibility": "full",
      "compatibilityNotes": "Map Fields tool in Velocity provides equivalent schema transformation functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "inputFields",
          "geoEventParamLabel": "Input Fields",
          "velocityParam": "inputFields",
          "velocityParamLabel": "Input Fields"
        },
        {
          "geoEventParam": "outputFields",
          "geoEventParamLabel": "Output Fields",
          "velocityParam": "outputFields",
          "velocityParamLabel": "Output Fields"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/map-fields.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/IncidentDetector",
      "geoEventProcessorLabel": "Incident Detector",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/incident-detector-processor.htm",
      "velocityEquivalent": "incident-detector",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/detect-incidents.htm",
      "compatibility": "full",
      "compatibilityNotes": "Detect Incidents tool in Velocity provides equivalent incident detection functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "openingCondition",
          "geoEventParamLabel": "Opening Condition",
          "velocityParam": "openCondition",
          "velocityParamLabel": "Open Condition"
        },
        {
          "geoEventParam": "closingCondition",
          "geoEventParamLabel": "Closing Condition",
          "velocityParam": "closeCondition",
          "velocityParamLabel": "Close Condition"
        },
        {
          "geoEventParam": "incidentType",
          "geoEventParamLabel": "Incident Type (Cumulative/Point in Time)",
          "velocityParam": "returnIncidentsOnly",
          "velocityParamLabel": "Return Incidents Only"
        },
        {
          "geoEventParam": "expiryTime",
          "geoEventParamLabel": "Expiry Time (seconds)",
          "velocityParam": "targetTimeWindow",
          "velocityParamLabel": "Target Time Window"
        },
        {
          "geoEventParam": "incidentName",
          "geoEventParamLabel": "Incident Name",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity uses IncidentId, IncidentStatus, IncidentDuration output fields)"
        },
        {
          "geoEventParam": "severity",
          "geoEventParamLabel": "Severity (Notification/Warning/Urgent)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (no severity levels in Velocity Detect Incidents)"
        },
        {
          "geoEventParam": "geometryType",
          "geoEventParamLabel": "Geometry Type (Point/Multipoint/Polyline)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity preserves source geometry)"
        },
        {
          "geoEventParam": "keepSourceFields",
          "geoEventParamLabel": "Keep Source Fields",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity always includes source fields with incident fields appended)"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/detect-incidents.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/Projector",
      "geoEventProcessorLabel": "Projector",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/projector-processor.htm",
      "velocityEquivalent": "project",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/project.htm",
      "compatibility": "full",
      "compatibilityNotes": "Project tool in Velocity provides equivalent spatial reference projection functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "outwkid",
          "geoEventParamLabel": "Output Spatial Reference (WKID)",
          "velocityParam": "wkid",
          "velocityParamLabel": "Spatial Reference (WKID)"
        },
        {
          "geoEventParam": "inputGeometryField",
          "geoEventParamLabel": "Input Geometry Field",
          "velocityParam": "geometryField",
          "velocityParamLabel": "Geometry Field"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/project.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/BearingProcessor",
      "geoEventProcessorLabel": "Bearing Calculator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/bearing-calculator-processor.htm",
      "velocityEquivalent": "motion-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-motion-statistics.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Bearing Calculator. Calculate Motion Statistics can compute heading/bearing as part of track analysis. Alternatively, Calculate Field with Arcade expressions can compute bearing values.",
      "limitations": [
        "No dedicated bearing calculator",
        "Requires Arcade expression or Calculate Motion Statistics"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "originSource",
          "geoEventParamLabel": "Origin Source",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Calculate Motion Statistics derives heading from sequential track observations)"
        },
        {
          "geoEventParam": "destinationSource",
          "geoEventParamLabel": "Destination Source",
          "velocityParam": "",
          "velocityParamLabel": "N/A (heading is calculated from sequential positions, not origin/destination pairs)"
        },
        {
          "geoEventParam": "outputBearingField",
          "geoEventParamLabel": "Output Bearing Field",
          "velocityParam": "heading",
          "velocityParamLabel": "Heading (output field, geodetic bearing in degrees)"
        },
        {
          "geoEventParam": "createBearingSegment",
          "geoEventParamLabel": "Create Bearing Segment",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity does not create bearing segment geometries)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "motion-calculator",
          "description": "Calculate Motion Statistics computes heading, speed, and acceleration for tracked entities",
          "tradeoffs": [
            "Requires track-aware data",
            "Computes additional statistics beyond bearing"
          ],
          "recommended": true
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-motion-statistics.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/ConvexHullCreator",
      "geoEventProcessorLabel": "Convex Hull Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/convex-hull-creator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Convex Hull Creator. The Calculate Field tool with the ArcGIS Arcade ConvexHull() geometry function produces the convex hull of an input geometry. Configuration differs from the GeoEvent Convex Hull Creator and requires an Arcade geometry expression.",
      "limitations": [
        "No dedicated convex hull tool",
        "Requires an Arcade geometry expression using ConvexHull()"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use ConvexHull() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "reconstruct-tracks",
          "description": "Manual Velocity Online Big Data Analytics post-processing alternative for track-based convex hull generation",
          "tradeoffs": [
            "Not available as a Velocity for ArcGIS Enterprise real-time analytic substitute",
            "Requires track-aware data and a separate post-processing workflow"
          ],
          "recommended": false
        }
      ],
      "arcadeAlternative": {
        "functions": ["ConvexHull"],
        "note": "Calculate Field with the ArcGIS Arcade ConvexHull() geometry function produces the convex hull of an input geometry."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/DifferenceCreator",
      "geoEventProcessorLabel": "Difference Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/difference-creator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Difference Creator. The Calculate Field tool with the ArcGIS Arcade Difference() geometry function computes the geometric difference of two geometries. The Overlay Layers tool (Erase) is an alternative when differencing against a separate reference layer rather than a per-event geometry field.",
      "limitations": [
        "No dedicated difference tool",
        "Requires an Arcade geometry expression using Difference()"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use Difference() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "overlay",
          "description": "Overlay Layers tool (Overlay Type: Erase) computes geometric difference against a separate reference layer rather than a per-event geometry field",
          "tradeoffs": [
            "Operates between two layers and joins their attributes, not on a single event geometry field",
            "Erase requires the input geometry dimension to be less than or equal to the erasing layer dimension"
          ],
          "recommended": false
        }
      ],
      "arcadeAlternative": {
        "functions": ["Difference"],
        "note": "Calculate Field with the ArcGIS Arcade Difference() geometry function computes the geometric difference of two geometries."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/EnvelopeCreator",
      "geoEventProcessorLabel": "Envelope Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/envelope-creator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Envelope Creator. Calculate Field with Arcade geometry functions can compute envelope/extent geometries.",
      "limitations": [
        "No dedicated envelope creator",
        "Requires Arcade geometry expressions"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use Extent() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [],
      "arcadeAlternative": {
        "functions": ["Extent"],
        "note": "Calculate Field with the ArcGIS Arcade Extent() geometry function returns the bounding envelope (extent) of an input geometry."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/EventJoiner",
      "geoEventProcessorLabel": "Event Joiner",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/event-joiner-processor.htm",
      "velocityEquivalent": "join-features",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "compatibility": "full",
      "compatibilityNotes": "Join Features tool in Velocity provides equivalent event joining functionality for combining attributes from multiple event streams.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "joinGEDName",
          "geoEventParamLabel": "Join GeoEvent Definition",
          "velocityParam": "joinSource",
          "velocityParamLabel": "Join Source (data source or second feed input)"
        },
        {
          "geoEventParam": "joinFieldName",
          "geoEventParamLabel": "Join Field",
          "velocityParam": "joinKeyField",
          "velocityParamLabel": "Join Key Field"
        },
        {
          "geoEventParam": "eventFieldName",
          "geoEventParamLabel": "Event Field",
          "velocityParam": "targetKeyField",
          "velocityParamLabel": "Target Key Field"
        },
        {
          "geoEventParam": "timeout",
          "geoEventParamLabel": "Timeout (seconds)",
          "velocityParam": "joinTimeWindow",
          "velocityParamLabel": "Join Time Window"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/join-features.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/EventVolumeController",
      "geoEventProcessorLabel": "Event Volume Controller",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/event-volume-controller-processor.htm",
      "velocityEquivalent": "event-volume-controller",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/control-event-volume.htm",
      "compatibility": "full",
      "compatibilityNotes": "Control Event Volume tool in Velocity provides equivalent event throttling and volume control.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "notificationType",
          "geoEventParamLabel": "Notification Type",
          "velocityParam": "filterType",
          "velocityParamLabel": "Filter Type"
        },
        {
          "geoEventParam": "interval",
          "geoEventParamLabel": "Interval (seconds)",
          "velocityParam": "timeInterval",
          "velocityParamLabel": "Time Interval"
        },
        {
          "geoEventParam": "maxEventCount",
          "geoEventParamLabel": "Maximum Event Count",
          "velocityParam": "maxCount",
          "velocityParamLabel": "Maximum Count"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/control-event-volume.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FeatureToPointProcessor",
      "geoEventProcessorLabel": "Feature to Point",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/feature-to-point-processor.htm",
      "velocityEquivalent": "feature-to-point",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/feature-to-point.htm",
      "compatibility": "full",
      "compatibilityNotes": "Feature to Point tool in Velocity provides equivalent geometry conversion functionality. The Velocity tool supports multipoint, polyline, polygon, and envelope geometry types. Point and tabular data are not supported.",
      "limitations": [
        "Point and tabular input geometry types are not supported",
        "GeoEvent 'replaceGeometry' and output field options have no direct Velocity equivalent; Velocity always replaces the geometry"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "inputGeometryField",
          "geoEventParamLabel": "Input Geometry Field",
          "velocityParam": "geometryField",
          "velocityParamLabel": "Geometry Field"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "pointInsideFeature",
          "velocityParamLabel": "Point Should Be Inside Parent Feature"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/feature-to-point.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldCalculatorRegex",
      "geoEventProcessorLabel": "Field Calculator (Regular Expression)",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-calculator-regular-expression-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity's Calculate Field tool evaluates ArcGIS Arcade expressions only, and Arcade has no native regular-expression support (no match/test function; Find performs literal search with no wildcards). The GeoEvent regex cannot be reused directly. Simple, fixed patterns can be approximated with Arcade text functions (Find, Mid, Left, Right, Replace, Split); complex extraction or replacement patterns should be applied upstream before ingest or handled by an external service.",
      "limitations": [
        "Velocity Calculate Field is Arcade-only; Arcade has no regular-expression engine",
        "Regex-based extraction/replacement must be approximated with Arcade text functions, applied upstream, or handled externally",
        "Only simple, fixed-shape patterns can be approximated in Arcade; arbitrary regex cannot be reproduced"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "regexExpression",
          "geoEventParamLabel": "Regular Expression",
          "velocityParam": "expression",
          "velocityParamLabel": "Arcade Expression (no native regex; approximate with text functions or handle upstream)"
        },
        {
          "geoEventParam": "targetField",
          "geoEventParamLabel": "Target Field",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name"
        },
        {
          "geoEventParam": "sourceField",
          "geoEventParamLabel": "Source Field",
          "velocityParam": "sourceField",
          "velocityParamLabel": "Source Field (referenced in Arcade expression)"
        }
      ],
      "alternatives": [],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Velocity Calculate Field is Arcade-only and Arcade has no regular-expression engine. For simple, fixed patterns, approximate the extraction/replacement with Arcade text functions (Find, Mid, Left, Right, Replace, Split) in the Calculate Field tool (https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm)",
          "manual": true
        },
        {
          "step": 2,
          "action": "For complex or arbitrary patterns that cannot be approximated in Arcade, apply the regular expression upstream before ingest (at the data producer or a pre-ingest transform) or route the data through an external service, then feed the derived field into Velocity",
          "manual": true
        },
        {
          "step": 3,
          "action": "Configure target field name in Calculate Field tool",
          "manual": false,
          "autoValue": "mapped from targetField"
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldEnricher-FeatureService",
      "geoEventProcessorLabel": "Field Enricher (Feature Service)",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-enricher-feature-service-processor.htm",
      "velocityEquivalent": "feature-layer-source",
      "velocityType": "data-source",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "compatibility": "partial",
      "compatibilityNotes": "In Velocity, field enrichment from a feature service is achieved by configuring a Feature Layer data source in a real-time analytic. The data source loads static or near real-time data that can be used by tools to enrich, filter, join to, or calculate distance from incoming events. The GeoEvent processor-level enrichment concept maps to a combination of a data source and an analytic tool in Velocity.",
      "limitations": [
        "Requires configuring a Feature Layer data source in the real-time analytic",
        "Data from a data source is loaded once when the analytic starts; for dynamic data, a feed should be used instead",
        "GeoEvent cache settings (refresh interval, max cache size) do not have direct equivalents",
        "Join field configuration must be reconfigured in the Velocity analytic tool"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "service",
          "geoEventParamLabel": "Feature Service",
          "velocityParam": "featureLayerUrl",
          "velocityParamLabel": "Feature Layer URL"
        },
        {
          "geoEventParam": "layer",
          "geoEventParamLabel": "Layer",
          "velocityParam": "layerIndex",
          "velocityParamLabel": "Layer"
        },
        {
          "geoEventParam": "fields",
          "geoEventParamLabel": "Enrichment Fields",
          "velocityParam": "fields",
          "velocityParamLabel": "Fields"
        },
        {
          "geoEventParam": "eventJoinFieldName",
          "geoEventParamLabel": "Event Join Field",
          "velocityParam": "joinKeyField",
          "velocityParamLabel": "Key Field"
        },
        {
          "geoEventParam": "dataJoinFieldName",
          "geoEventParamLabel": "Data Join Field",
          "velocityParam": "sourceKeyField",
          "velocityParamLabel": "Source Key Field"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "join-features",
          "description": "Join Features analytic tool can also enrich events by joining attributes from a feature layer based on spatial or attribute relationships",
          "tradeoffs": [
            "Requires a data source to be configured separately",
            "Provides more flexible join options including spatial joins"
          ],
          "recommended": false
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/what-is-a-data-source-.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldEnricher-File",
      "geoEventProcessorLabel": "Field Enricher (File)",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-enricher-file-processor.htm",
      "velocityEquivalent": "join-features",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not support file-based enrichment directly. The lookup data must be published as a feature layer, then Join Features can be used for enrichment.",
      "limitations": [
        "Lookup file must be published as a feature layer",
        "No direct file-based enrichment"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "filePath",
          "geoEventParamLabel": "File Path",
          "velocityParam": "joinSource",
          "velocityParamLabel": "Join Source (publish lookup file as Feature Layer data source)"
        },
        {
          "geoEventParam": "joinFieldName",
          "geoEventParamLabel": "Join Field",
          "velocityParam": "joinKeyField",
          "velocityParamLabel": "Join Key Field"
        },
        {
          "geoEventParam": "enrichmentFields",
          "geoEventParamLabel": "Enrichment Fields",
          "velocityParam": "joinFields",
          "velocityParamLabel": "Join Fields"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/join-features.html"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/FieldSplitter",
      "geoEventProcessorLabel": "Field Splitter",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "compatibility": "partial",
      "compatibilityNotes": "When the Field Splitter follows a GeoTagger processor to split comma-delimited geofence intersection results into individual events, the recommended approach is the Join Features tool configured with a One-to-Many spatial join, which produces a separate event per geofence intersection and removes the need for a separate splitting step. For standalone splitting of delimited or multivalue field content (without a preceding GeoTagger), evaluate the Velocity Split by Attributes tool; confirm its delimiter and array-handling behavior matches the GeoEvent Field Splitter for your data.",
      "limitations": [
        "No single tool reproduces every Field Splitter mode; the right Velocity tool depends on how the splitter is used",
        "When used with a GeoTagger, the Join Features tool with One-to-Many join replaces both the GeoTagger and Field Splitter",
        "Standalone field-value splitting (without a preceding GeoTagger) maps to the Velocity Split by Attributes tool; validate that its delimiter and array-handling behavior matches the GeoEvent Field Splitter"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "fieldToSplit",
          "geoEventParamLabel": "Field to Split",
          "velocityParam": "joinType",
          "velocityParamLabel": "Join Operation (configure as One-to-Many)"
        },
        {
          "geoEventParam": "fieldSplitter",
          "geoEventParamLabel": "Delimiter",
          "velocityParam": "",
          "velocityParamLabel": "N/A (handled by One-to-Many join)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "split-by-attributes",
          "description": "Split by Attributes splits events based on multivalue or delimited attribute content. Use for standalone Field Splitter scenarios with no preceding GeoTagger.",
          "tradeoffs": [
            "Delimiter and array-handling semantics may differ from the GeoEvent Field Splitter and should be validated"
          ],
          "recommended": false
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/join-features.html",
      "geoEventGalleryItemId": "68238a93e5fd4043ad0bbb501b265566"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FieldReducer",
      "geoEventProcessorLabel": "Field Reducer",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/field-reducer-processor.htm",
      "velocityEquivalent": "field-selector",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/select-fields.htm",
      "compatibility": "full",
      "compatibilityNotes": "Select Fields tool in Velocity provides equivalent functionality for removing unwanted fields from the event schema.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "fieldsToRemove",
          "geoEventParamLabel": "Fields to Remove",
          "velocityParam": "fieldsToKeep",
          "velocityParamLabel": "Fields to Keep (inverse selection: specify fields to retain)"
        },
        {
          "geoEventParam": "outputDefinitionName",
          "geoEventParamLabel": "Output GeoEvent Definition",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity automatically generates the output schema)"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/select-fields.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/Intersector",
      "geoEventProcessorLabel": "Intersector",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/intersector-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Intersector. The Calculate Field tool with the ArcGIS Arcade Intersection() geometry function computes the geometric intersection of two geometries. The Overlay Layers tool (Intersect) is an alternative when intersecting against a separate reference layer rather than a per-event geometry field.",
      "limitations": [
        "No dedicated intersector tool",
        "Requires an Arcade geometry expression using Intersection()",
        "Intersects() returns a boolean relationship test, not a geometry; use Intersection() for geometry output"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use Intersection() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "overlay",
          "description": "Overlay Layers tool (Overlay Type: Intersect) computes geometric intersection against a separate reference layer rather than a per-event geometry field",
          "tradeoffs": [
            "Operates between two layers and joins their attributes, not on a single event geometry field"
          ],
          "recommended": false
        }
      ],
      "arcadeAlternative": {
        "functions": ["Intersection"],
        "note": "Calculate Field with the ArcGIS Arcade Intersection() geometry function computes the geometric intersection of two geometries (Intersects() is a boolean relationship test, not a geometry)."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/NoOperation",
      "geoEventProcessorLabel": "No Operation",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/no-operation-processor.htm",
      "velocityEquivalent": "",
      "velocityType": "",
      "velocityHelpUrl": "",
      "compatibility": "full",
      "compatibilityNotes": "The No Operation processor is a pass-through used for debugging in GeoEvent Server; it has no effect on the event record. Velocity has no dedicated no-op tool, and in most cases the node can simply be omitted because removing it does not change the data. If a placeholder is needed to preserve the flow's structure (for example, to keep a labeled step or a branch point), a Filter configured with an always-true expression (such as 1 = 1) passes every event through unchanged, or a Field Calculator with an Arcade expression that returns an existing field's current value produces no net change.",
      "limitations": [
        "No dedicated no-op/pass-through tool in Velocity; the placeholder options are workarounds, not a one-to-one component",
        "A Field Calculator placeholder must target a field and re-assign its existing value, which is less clean than a pass-through Filter"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "filter-by-expression",
          "description": "Add a Filter with an always-true condition (for example 1 = 1) so every event passes through unchanged. This is the closest no-op placeholder when the node must be retained to preserve flow structure.",
          "tradeoffs": [
            "Adds a node that does nothing functionally; prefer omitting the No Operation step entirely when topology preservation is not required"
          ],
          "recommended": true
        },
        {
          "velocityComponent": "field-calculator",
          "description": "Use a Field Calculator with an Arcade expression that returns an existing field's current value (for example $feature.TRACK_ID), producing no net change to the record.",
          "tradeoffs": [
            "Requires choosing a target field and re-assigning its own value; less clean than an always-true Filter"
          ],
          "recommended": false
        }
      ]
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/RangeFanProcessor",
      "geoEventProcessorLabel": "Range Fan Calculator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/range-fan-calculator-processor.htm",
      "velocityEquivalent": "range-fan",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/create-range-fans.htm",
      "compatibility": "full",
      "compatibilityNotes": "Create Range Fans tool in Velocity provides equivalent range fan geometry creation.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "bearing",
          "geoEventParamLabel": "Bearing Field",
          "velocityParam": "bearing",
          "velocityParamLabel": "Bearing"
        },
        {
          "geoEventParam": "range",
          "geoEventParamLabel": "Range Field",
          "velocityParam": "range",
          "velocityParamLabel": "Range"
        },
        {
          "geoEventParam": "traversal",
          "geoEventParamLabel": "Traversal Field",
          "velocityParam": "traversal",
          "velocityParamLabel": "Traversal"
        },
        {
          "geoEventParam": "rangeUnit",
          "geoEventParamLabel": "Range Unit",
          "velocityParam": "distanceUnit",
          "velocityParamLabel": "Distance Unit"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/create-range-fans.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/Simplifier",
      "geoEventProcessorLabel": "Simplifier",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/simplifier-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated geometry simplifier. Calculate Field with Arcade geometry functions (Generalize or Simplify) can simplify geometries.",
      "limitations": [
        "No dedicated simplifier",
        "Requires Arcade geometry expressions"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "tolerance",
          "geoEventParamLabel": "Tolerance",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use Generalize() geometry function with tolerance)"
        },
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [],
      "arcadeAlternative": {
        "functions": ["Generalize", "Simplify"],
        "note": "Calculate Field with the ArcGIS Arcade Generalize() (vertex reduction) or Simplify() (topological repair) geometry function simplifies geometries."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/SymmetricDifferenceCreator",
      "geoEventProcessorLabel": "Symmetric Difference Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/symmetric-difference-creator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Symmetric Difference Creator. The Calculate Field tool with the ArcGIS Arcade SymmetricDifference() geometry function computes the symmetric difference of two geometries. The Overlay Layers tool (Symmetric Difference) is an alternative when operating against a separate reference layer; it requires both layers to be the same geometry type.",
      "limitations": [
        "No dedicated symmetric difference tool",
        "Requires an Arcade geometry expression using SymmetricDifference()"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use SymmetricDifference() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "overlay",
          "description": "Overlay Layers tool (Overlay Type: Symmetric Difference) operates against a separate reference layer rather than a per-event geometry field",
          "tradeoffs": [
            "Operates between two layers and joins their attributes, not on a single event geometry field",
            "Requires both layers to be the same geometry type"
          ],
          "recommended": false
        }
      ],
      "arcadeAlternative": {
        "functions": ["SymmetricDifference"],
        "note": "Calculate Field with the ArcGIS Arcade SymmetricDifference() geometry function computes the symmetric difference of two geometries."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/TrackGapDetector",
      "geoEventProcessorLabel": "Track Gap Detector",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/track-gap-detector-processor.htm",
      "velocityEquivalent": "detect-gaps",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/detect-gaps.htm",
      "compatibility": "full",
      "compatibilityNotes": "Detect Gaps tool in Velocity provides equivalent track gap detection functionality.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "maxGapDuration",
          "geoEventParamLabel": "Maximum Gap Duration",
          "velocityParam": "timeWindow",
          "velocityParamLabel": "Time Window"
        },
        {
          "geoEventParam": "trackIdField",
          "geoEventParamLabel": "Track ID Field",
          "velocityParam": "trackIdField",
          "velocityParamLabel": "Track ID Field"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/detect-gaps.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/UnionCreator",
      "geoEventProcessorLabel": "Union Creator",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/union-creator-processor.htm",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-field.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated Union Creator. The Calculate Field tool with the ArcGIS Arcade Union() geometry function combines an array of geometries into a single geometry. The Overlay Layers tool (Union) is an alternative when combining a separate reference layer; it is valid only for polygon-to-polygon overlays.",
      "limitations": [
        "No dedicated union tool",
        "Requires an Arcade geometry expression using Union()",
        "Union() takes an array of geometries rather than a binary pair"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (use Union() geometry function)"
        },
        {
          "geoEventParam": "replaceGeometry",
          "geoEventParamLabel": "Replace Geometry",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (target geometry field)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "overlay",
          "description": "Overlay Layers tool (Overlay Type: Union) combines a separate reference layer rather than a per-event geometry field",
          "tradeoffs": [
            "Operates between two layers and joins their attributes, not on a single event geometry field",
            "Valid only for polygon-to-polygon overlays"
          ],
          "recommended": false
        }
      ],
      "arcadeAlternative": {
        "functions": ["Union"],
        "note": "Calculate Field with the ArcGIS Arcade Union() geometry function combines an array of geometries into a single geometry."
      },
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-field.html"
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/DelayAndReorderProcessor",
      "geoEventProcessorLabel": "Delay and Reorder Tracks",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "delay-and-reorder-tracks",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/delay-and-reorder-tracks.htm",
      "compatibility": "full",
      "compatibilityNotes": "Delay and Reorder Tracks tool in Velocity delays and reorders out-of-sequence track observations.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "timeWindow",
          "geoEventParamLabel": "Time Window",
          "velocityParam": "delay-and-reorder-tracks.timeWindow",
          "velocityParamLabel": "Time Window"
        },
        {
          "geoEventParam": "maxFeatures",
          "geoEventParamLabel": "Maximum Features",
          "velocityParam": "delay-and-reorder-tracks.maxFeaturesWithinTimeWindow",
          "velocityParamLabel": "Max Features Within Time Window"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/delay-and-reorder-tracks.html",
      "geoEventGalleryItem": true
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/DistanceCalculator",
      "geoEventProcessorLabel": "Distance Calculator",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "distance-to-feature-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-distance.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Calculate Distance tool in Velocity calculates distance between event features and join features. Requires a Feature Layer data source as the join input.",
      "limitations": [
        "Join data must be available as a Feature Layer data source",
        "GeoEvent distance references may need reconfiguration"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "distanceUnit",
          "geoEventParamLabel": "Distance Unit",
          "velocityParam": "distance-to-feature-calculator.outputDistanceUnits",
          "velocityParamLabel": "Output Distance Units"
        },
        {
          "geoEventParam": "spatialRelationship",
          "geoEventParamLabel": "Spatial Relationship",
          "velocityParam": "distance-to-feature-calculator.spatialRelationship",
          "velocityParamLabel": "Spatial Relationship"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-distance.html",
      "geoEventGalleryItem": true
    },
    {
      "geoEventProcessor": "com.esri.ges.processor/FilterByTimeRange",
      "geoEventProcessorLabel": "Filter by Time Range",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "filter-by-time-range",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-time-range.htm",
      "compatibility": "full",
      "compatibilityNotes": "Filter by Time Range tool in Velocity filters events based on temporal constraints.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "timeRange",
          "geoEventParamLabel": "Time Range",
          "velocityParam": "filter-by-time-range.time",
          "velocityParamLabel": "Time Configuration"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-time-range.html",
      "geoEventGalleryItem": true
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/MulticardinalFieldSplitter",
      "geoEventProcessorLabel": "Multicardinal Field Splitter",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "field-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/join-features.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/join-features.html",
      "compatibility": "partial",
      "compatibilityNotes": "The Multicardinal Field Splitter splits a hierarchical field group (array) into individual GeoEvents, useful for splitting vehicle-drivers arrays or similar one-to-many structures. Velocity does not have a direct equivalent. Approximate this in Velocity with a Join Features tool configured as One-to-Many when the array is reachable via a join, or pre-process the data upstream so each child element is its own event. Standalone in-place array splitting is on the Velocity roadmap.",
      "limitations": [
        "No direct multicardinal field-group splitting in Velocity",
        "Duplicate-field-name disambiguation (prepend parent name, append unique number) must be re-implemented if needed",
        "The _childindex tracking field has no Velocity counterpart"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "fieldToSplit",
          "geoEventParamLabel": "Field to Split",
          "velocityParam": "joinType",
          "velocityParamLabel": "Join Operation (configure as One-to-Many)"
        },
        {
          "geoEventParam": "newGeoEventDefinitionName",
          "geoEventParamLabel": "New GeoEvent Definition Name",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity infers output schema)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "field-calculator",
          "description": "Pre-flatten hierarchical arrays upstream using a Field Calculator analytic with array-indexing expressions.",
          "tradeoffs": [
            "Requires expression authoring per source schema",
            "Cardinality of output events is fixed at analytic-design time"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "68238a93e5fd4043ad0bbb501b265566"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/MotionCalculator",
      "geoEventProcessorLabel": "Motion Calculator",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "motion-calculator",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-motion-statistics.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/calculate-motion-statistics.html",
      "compatibility": "full",
      "compatibilityNotes": "Velocity provides a dedicated Motion Calculator analytic that mirrors the GeoEvent gallery processor. It calculates distance, timespan, speed, acceleration, heading, and per-track statistics (min/max/avg/cumulative) from point-based events keyed by TRACK_ID and TIME_START.",
      "limitations": [
        "GeoEvent's predictive-timespan proof-of-concept output fields are not exposed in Velocity",
        "Cache-reset scheduling (resetCacheAt time-of-day) is not user-configurable in Velocity"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "distanceUnit",
          "geoEventParamLabel": "Distance Unit",
          "velocityParam": "distanceUnit",
          "velocityParamLabel": "Distance Unit"
        },
        {
          "geoEventParam": "geometryType",
          "geoEventParamLabel": "Geometry Type",
          "velocityParam": "outputGeometryType",
          "velocityParamLabel": "Output Geometry Type"
        },
        {
          "geoEventParam": "countNotificationMode",
          "geoEventParamLabel": "Notification Mode",
          "velocityParam": "notificationMode",
          "velocityParamLabel": "Notification Mode"
        },
        {
          "geoEventParam": "reportInterval",
          "geoEventParamLabel": "Report Interval (seconds)",
          "velocityParam": "reportInterval",
          "velocityParamLabel": "Report Interval"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "03c440742bbd4686b16420164d30e448"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/Delay",
      "geoEventProcessorLabel": "Delay",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity has no Delay analytic equivalent. The GeoEvent Delay processor delays events by a fixed interval for historical playback or temporal-ordering enforcement. In Velocity, simulate this by writing events to a time-windowed buffer (BigDataStore + scheduled feature-layer feed) or by routing through an external scheduling service.",
      "limitations": [
        "No native event-delay analytic in Velocity (Online or Enterprise)",
        "Enforce-delay-threshold and duplicate-detection logic must be reimplemented",
        "Memory-intensive for high-velocity streams; downstream architecture must be sized accordingly"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "field-calculator",
          "description": "For simple TIME_START-based ordering enforcement, use a Field Calculator analytic to compute a delay marker and drop events outside the window.",
          "tradeoffs": [
            "Does not actually delay events; only flags or drops out-of-order",
            "Requires upstream buffering for true delay semantics"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "1e37ccff6b764227b517b69c9dd98a36"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/TrackIdleDetector",
      "geoEventProcessorLabel": "Track Idle Detector",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "detect-gaps",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/detect-gaps.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/detect-gaps.html",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity's Track Gaps analytic detects gaps in track reporting (similar idle-detection use case). The GeoEvent Track Idle Detector emits explicit TrackIdle GeoEvent Definitions with idle/idleDuration/idleStart fields, while Velocity's Track Gaps emits gap events with different schema. Tolerance-distance (must-move-beyond) semantics may need analytical augmentation in Velocity.",
      "limitations": [
        "Track Gaps detects stop-reporting gaps, not movement-tolerance idleness; combine with Geofence Tool or Field Calculator for movement-based idle detection",
        "Reserved field names 'idle', 'IdleDuration', 'idleStart' must be re-mapped",
        "OnChange vs. Continuous notification modes must be modeled differently"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "maximumTimeAllowedForIdling",
          "geoEventParamLabel": "Maximum Time Allowed for Idling (seconds)",
          "velocityParam": "gapThreshold",
          "velocityParamLabel": "Gap Threshold"
        },
        {
          "geoEventParam": "tolerance",
          "geoEventParamLabel": "Tolerance",
          "velocityParam": "",
          "velocityParamLabel": "N/A (use Geofence Tool for movement-tolerance detection)"
        },
        {
          "geoEventParam": "idleNotificationMode",
          "geoEventParamLabel": "Idle Notification Mode",
          "velocityParam": "notificationMode",
          "velocityParamLabel": "Notification Mode"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "geofence-tool",
          "description": "Combine Track Gaps with a small-radius geofence around each track's last known position to detect movement-tolerance idleness.",
          "tradeoffs": [
            "More complex analytic chain",
            "Per-track geofences may require dynamic geofence creation"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "5d8e3446736d4df299c7c96bc275d561"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/Timetree",
      "geoEventProcessorLabel": "Timetree",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "reconstruct-tracks",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/reconstruct-tracks.htm",
      "compatibility": "full",
      "compatibilityNotes": "Velocity's Create Track Line or Polygon analytic creates breadcrumb line/polygon geometry from cached historical points, equivalent to the GeoEvent Timetree processor. Use the time-window or event-count modes to bound the cache size.",
      "limitations": [
        "Velocity cache eviction is internal and not exposed; tune via the analytic's window settings"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "useEventCount",
          "geoEventParamLabel": "Use Event Count",
          "velocityParam": "windowType",
          "velocityParamLabel": "Window Type"
        },
        {
          "geoEventParam": "eventWindowSize",
          "geoEventParamLabel": "Event Window Size",
          "velocityParam": "windowSize",
          "velocityParamLabel": "Window Size"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "95cffd6166f948a69a946ae5dc862817"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/UpdatesOnly",
      "geoEventProcessorLabel": "Updates Only",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "filter-by-expression",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-expression.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-expression.html",
      "compatibility": "partial",
      "compatibilityNotes": "The GeoEvent Updates Only processor caches the latest TIME_START per TRACK_ID and drops older events. Velocity's Filter by Attribute can compare TIME_START to a per-track maximum when paired with a stateful Field Calculator analytic that maintains the per-track timestamp cache. For simpler deduplication, use Filter by Time Range with a sliding window.",
      "limitations": [
        "No single-step 'newest per track' analytic in Velocity; requires Field Calculator + Filter combination",
        "Per-track timestamp cache must be maintained explicitly",
        "Without TRACK_ID and TIME_START tags, the analytic cannot function (matches GeoEvent behaviour)"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "clearCache",
          "geoEventParamLabel": "Clear Cache",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity manages analytic state automatically)"
        }
      ],
      "alternatives": [
        {
          "velocityComponent": "filter-by-time-range",
          "description": "If only the latest event in a sliding time window is needed (rather than strictly newest-per-track), use Filter by Time Range.",
          "tradeoffs": [
            "Time-window semantics differ from per-track newest-only"
          ],
          "recommended": false
        }
      ],
      "geoEventGalleryItemId": "d730006ab676494594405df260f9d076"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor.geonames/GeoNamesOSMPOI",
      "geoEventProcessorLabel": "GeoNames OpenStreetMap Lookup Processor",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity has no GeoNames or OpenStreetMap lookup analytic. The GeoEvent processor uses the GeoNames web service to enrich events with nearest POIs within a radius. Approximate in Velocity by hosting POI data as a feature layer and using the Join Features (One-to-Many) analytic for spatial enrichment.",
      "limitations": [
        "No GeoNames web service integration in Velocity",
        "POI data must be hosted as a feature layer for Join Features",
        "OpenStreetMap data licensing must be re-evaluated for redistribution"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "join-features",
          "description": "Host POI data as a Velocity feature layer; use Join Features with spatial One-to-Many join to enrich events.",
          "tradeoffs": [
            "Requires ingesting and maintaining POI feature data",
            "No real-time updates from the GeoNames service"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "d9db42537c74437da84288930ced6c81"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor.geonames/GeoNamesWikipedia",
      "geoEventProcessorLabel": "GeoNames Wikipedia Lookup Processor",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityEquivalentEnterprise": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityEnterprise": "none",
      "compatibilityNotes": "Velocity has no Wikipedia lookup analytic. The GeoEvent processor uses the GeoNames Wikipedia web service to enrich events with nearest georeferenced articles within a radius. Approximate in Velocity by hosting a Wikipedia article feature layer (subset of interest) and using Join Features for spatial enrichment.",
      "limitations": [
        "No GeoNames Wikipedia service integration in Velocity",
        "Wikipedia article geo-data must be staged as a feature layer",
        "Article freshness depends on layer refresh cadence"
      ],
      "parameterMappings": [],
      "alternatives": [
        {
          "velocityComponent": "join-features",
          "description": "Stage a Wikipedia article feature layer; use Join Features for spatial enrichment.",
          "tradeoffs": [
            "Requires staging and refreshing Wikipedia data",
            "Limited to articles in the staged layer"
          ],
          "recommended": true
        }
      ],
      "geoEventGalleryItemId": "d9db42537c74437da84288930ced6c81"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/RendezvousDetector",
      "geoEventProcessorLabel": "Rendezvous Detector",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "incident-detector",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/detect-incidents.htm",
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/detect-incidents.html",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity's Incident Detector can model rendezvous (multiple tracks converging in time/space) by triggering on a proximity geofence and combining with track-aware filters. The GeoEvent Rendezvous Detector emits typed events (detected, joined, departed, ended, expired) that must be reconstructed as separate Velocity incident states. Auto-creation of party/rendezvous geofence categories has no Velocity equivalent; geofences must be created and maintained explicitly.",
      "limitations": [
        "Five typed event states (detected/joined/departed/ended/expired) must be modeled as separate Velocity incidents or via Field Calculator state machines",
        "Auto-generated geofence categories are not supported; manual geofence layer maintenance required",
        "Spatial-reference selection (state plane, UTM) carries over from the GeoEvent guidance"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "rendezvoussProximity",
          "geoEventParamLabel": "Rendezvous Proximity",
          "velocityParam": "bufferDistance",
          "velocityParamLabel": "Buffer Distance"
        },
        {
          "geoEventParam": "expiryTime",
          "geoEventParamLabel": "Expiry Time (seconds)",
          "velocityParam": "incidentTimeout",
          "velocityParamLabel": "Incident Timeout"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "33da33a584154d7b89bf766107878dfd"
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/ReverseGeocoder",
      "geoEventProcessorLabel": "Reverse Geocoder",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityNotes": "Velocity has no built-in Reverse Geocoder analytic. There is no Velocity tool for this and Arcade in Velocity does not expose a callable locator service. Continue running the GeoEvent processor in place, or invoke an external geocoding service from upstream of Velocity and pass the decoded address fields through as event attributes.",
      "limitations": [
        "World Geocoding Service usage consumes credits (ArcGIS Online); plan for cost at high event volumes",
        "Custom locator services must be registered with Velocity"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "searchRadius",
          "geoEventParamLabel": "Search Radius",
          "velocityParam": "searchDistance",
          "velocityParamLabel": "Search Distance"
        },
        {
          "geoEventParam": "resultingGeoEventDefinitionName",
          "geoEventParamLabel": "Resulting GeoEvent Definition Name",
          "velocityParam": "",
          "velocityParamLabel": "N/A (Velocity appends address fields to the existing schema)"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "7eed835dc2044a6787799de4f7cd0e45",
      "velocityEquivalentEnterprise": ""
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/LatLongToMGRS",
      "geoEventProcessorLabel": "Lat Long to MGRS Converter",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityNotes": "Velocity has no MGRS converter analytic. Arcade in Velocity has no built-in MGRS encoding, so the MGRS conversion math (UTM zone selection, band-letter computation, 100,000-meter grid square encoding, accuracy-level truncation 0-5) would have to be hand-ported into a Calculate Field expression. Treat as not migratable in practice; continue running the GeoEvent processor in place or invoke an external geometry service that returns MGRS strings.",
      "limitations": [
        "No native MGRS converter analytic in Velocity",
        "Accuracy levels (0=100km through 5=1m) must be encoded in the Arcade expression",
        "GitHub source for the GeoEvent processor can inform the Arcade implementation"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "geometryFieldName",
          "geoEventParamLabel": "Geometry Field Name",
          "velocityParam": "inputGeometryField",
          "velocityParamLabel": "Input Geometry Field"
        },
        {
          "geoEventParam": "accuracy",
          "geoEventParamLabel": "Accuracy (Precision Level)",
          "velocityParam": "",
          "velocityParamLabel": "N/A (encode precision in Arcade expression)"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "f34314728ae04664925dfb86ebc0bc3f",
      "velocityEquivalentEnterprise": ""
    },
    {
      "geoEventProcessor": "com.esri.geoevent.processor/MGRSToLatLong",
      "geoEventProcessorLabel": "MGRS to Lat Long Converter",
      "geoEventHelpUrl": "",
      "velocityEquivalent": "",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "",
      "velocityHelpUrlEnterprise": "",
      "compatibility": "none",
      "compatibilityNotes": "Velocity has no MGRS decoder analytic. Arcade in Velocity has no built-in MGRS parsing, so the inverse MGRS-to-WGS84 algorithm would have to be hand-ported into a Calculate Field expression. Treat as not migratable in practice; continue running the GeoEvent processor in place or invoke an external geometry service that converts MGRS strings to lat/lon coordinates.",
      "limitations": [
        "No native MGRS decoder in Velocity",
        "Bounding-box output (returnBoundingBox=true) must be modeled by computing the four corner coordinates explicitly",
        "Overwrite-geometry semantics handled by writing to the geometry field"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "mgrsField",
          "geoEventParamLabel": "MGRS Field",
          "velocityParam": "inputField",
          "velocityParamLabel": "Input Field"
        },
        {
          "geoEventParam": "overwriteGeometry",
          "geoEventParamLabel": "Overwrite Geometry",
          "velocityParam": "",
          "velocityParamLabel": "N/A (control via Field Calculator output target)"
        },
        {
          "geoEventParam": "returnBoundingBox",
          "geoEventParamLabel": "Return Bounding Box",
          "velocityParam": "",
          "velocityParamLabel": "N/A (construct bounding box in additional Field Calculator step)"
        }
      ],
      "alternatives": [],
      "geoEventGalleryItemId": "f34314728ae04664925dfb86ebc0bc3f",
      "velocityEquivalentEnterprise": ""
    }
  ],
  "filters": [
    {
      "geoEventFilter": "attribute-filter",
      "geoEventFilterLabel": "Attribute Filter",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/attribute-filters.htm",
      "velocityEquivalent": "filter-by-expression",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-expression.htm",
      "compatibility": "full",
      "compatibilityNotes": "Filter by Expression tool in Velocity supports equivalent attribute filtering.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "expression",
          "geoEventParamLabel": "Filter Expression",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression"
        },
        {
          "geoEventParam": "operator",
          "geoEventParamLabel": "Operator",
          "velocityParam": "",
          "velocityParamLabel": "N/A (operators embedded in Arcade expression)"
        }
      ],
      "alternatives": [],
      "migrationSteps": [
        {
          "step": 1,
          "action": "Convert GeoEvent filter expression and operator into a single Arcade expression. See the Velocity Arcade profile (https://developers.arcgis.com/arcade/profiles/velocity/) for supported syntax and the Arcade guide (https://doc.arcgis.com/en/iot/analyze/use-arcade-expressions.htm) for examples",
          "manual": true
        },
        {
          "step": 2,
          "action": "Configure Filter by Expression tool with Arcade expression",
          "manual": false,
          "autoValue": "tool auto-configured from matrix mapping"
        }
      ],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-expression.html"
    },
    {
      "geoEventFilter": "spatial-filter",
      "geoEventFilterLabel": "Spatial Filter",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/spatial-filters.htm",
      "velocityEquivalent": "filter-by-geometry",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-geometry.htm",
      "compatibility": "full",
      "compatibilityNotes": "Filter by Geometry tool in Velocity provides equivalent spatial filtering using geographic boundaries.",
      "limitations": [],
      "parameterMappings": [
        {
          "geoEventParam": "spatialRelationship",
          "geoEventParamLabel": "Spatial Relationship",
          "velocityParam": "spatialRelationship",
          "velocityParamLabel": "Spatial Relationship"
        },
        {
          "geoEventParam": "geofence",
          "geoEventParamLabel": "Geofence",
          "velocityParam": "filterGeometry",
          "velocityParamLabel": "Filter Geometry (Feature Layer data source)"
        },
        {
          "geoEventParam": "geometryField",
          "geoEventParamLabel": "Geometry Field",
          "velocityParam": "geometryField",
          "velocityParamLabel": "Geometry Field"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-geometry.html"
    },
    {
      "geoEventFilter": "tag-filter",
      "geoEventFilterLabel": "Tag Filter",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/create-filters-using-tags.htm",
      "velocityEquivalent": "filter-by-expression",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-expression.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated tag filter. Filter by Expression can replicate tag-based filtering using Arcade expressions that evaluate tag field values.",
      "limitations": [
        "No dedicated tag filter",
        "Tag-based conditions must be rewritten as Arcade expressions"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "tagCondition",
          "geoEventParamLabel": "Tag Condition",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (rewrite tag condition as field expression)"
        },
        {
          "geoEventParam": "tagField",
          "geoEventParamLabel": "Tag Field",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name (field containing tag values)"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-expression.html"
    },
    {
      "geoEventFilter": "regex-filter",
      "geoEventFilterLabel": "Regular Expression Filter",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/create-filters-using-regular-expressions.htm",
      "velocityEquivalent": "filter-by-expression",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-expression.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity has no dedicated regex filter, and its Filter by Expression tool evaluates ArcGIS Arcade only. Arcade has no native regular-expression support (no match/test function; Find performs literal search with no wildcards), so patterns cannot be reused as-is. Simple, fixed-shape patterns can be approximated with Arcade text functions (Find, Left, Right, Mid, Count, ToCharCode); the migration tool auto-generates such an approximation where possible and flags it for verification. Complex or arbitrary patterns should be applied upstream before ingest or handled by an external service.",
      "limitations": [
        "No dedicated regex filter; Filter by Expression is Arcade-only",
        "Arcade has no regular-expression engine",
        "Only simple, fixed-shape patterns can be approximated with Arcade text functions; arbitrary regex cannot be reproduced and should be handled upstream or externally"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "regexExpression",
          "geoEventParamLabel": "Regular Expression",
          "velocityParam": "expression",
          "velocityParamLabel": "Arcade Expression (no native regex; approximate with text functions or handle upstream)"
        },
        {
          "geoEventParam": "targetField",
          "geoEventParamLabel": "Target Field",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-expression.html"
    },
    {
      "geoEventFilter": "property-filter",
      "geoEventFilterLabel": "Property Filter",
      "geoEventHelpUrl": "https://enterprise.arcgis.com/en/geoevent/latest/analyze/property-filters.htm",
      "velocityEquivalent": "filter-by-expression",
      "velocityType": "analytic-tool",
      "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/filter-by-expression.htm",
      "compatibility": "partial",
      "compatibilityNotes": "Velocity does not have a dedicated property filter. Filter by Expression can replicate property-based filtering. GeoEvent Server property references must be rewritten as Arcade expressions.",
      "limitations": [
        "No dedicated property filter",
        "Property references must be rewritten as Arcade expressions"
      ],
      "parameterMappings": [
        {
          "geoEventParam": "propertyCondition",
          "geoEventParamLabel": "Property Condition",
          "velocityParam": "arcadeExpression",
          "velocityParamLabel": "Arcade Expression (rewrite property condition)"
        },
        {
          "geoEventParam": "propertyName",
          "geoEventParamLabel": "Property Name",
          "velocityParam": "fieldName",
          "velocityParamLabel": "Field Name"
        }
      ],
      "alternatives": [],
      "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/filter-by-expression.html"
    }
  ],
  "adapters": {
    "inbound": [
      {
        "uri": "com.esri.ges.adapter.inbound/Text",
        "label": "Text Adapter",
        "description": "Parses delimited text data",
        "velocityEquivalent": "delimited-text-parser",
        "compatibility": "full"
      },
      {
        "uri": "com.esri.ges.adapter.inbound/JSON",
        "label": "JSON Adapter",
        "description": "Parses JSON data",
        "velocityEquivalent": "json-parser",
        "compatibility": "full"
      },
      {
        "uri": "regexText-adapter",
        "label": "Regular Expression Text Adapter (regexText)",
        "description": "Extends the Text Adapter to parse text with complex or variable-width delimiters via a Java regular expression matcher; performs regex-based replacement before delegating to the standard Text Adapter. Pair with TCP, HTTP, UDP, or other inbound transports.",
        "velocityEquivalent": "delimited-text-parser",
        "compatibility": "partial",
        "geoEventGalleryItemId": "8a8fda6c78b8447da252b24954f651ca"
      }
    ],
    "outbound": [
      {
        "uri": "com.esri.ges.adapter.outbound/Text",
        "label": "Text Adapter",
        "description": "Formats data as delimited text",
        "velocityEquivalent": "text-formatter",
        "compatibility": "full"
      }
    ]
  },
  "transports": {
    "inbound": [
      {
        "uri": "com.esri.ges.transport.inbound/TCP",
        "label": "TCP Transport",
        "description": "Receives data over TCP",
        "velocityEquivalent": "tcp-connection",
        "compatibility": "partial"
      },
      {
        "uri": "com.esri.ges.transport.inbound/FeatureService",
        "label": "Feature Service Transport",
        "description": "Polls feature service for data",
        "velocityEquivalent": "feature-layer-connection",
        "compatibility": "full"
      },
      {
        "uri": "com.esri.ges.transport.inbound/File",
        "label": "File Transport",
        "description": "Reads data from files",
        "velocityEquivalent": "cloud-storage-connection",
        "compatibility": "partial"
      }
    ],
    "outbound": [
      {
        "uri": "com.esri.ges.transport.outbound/File",
        "label": "File Transport",
        "description": "Writes data to files",
        "velocityEquivalent": "feature-layer-output",
        "compatibility": "partial"
      }
    ]
  },
  "velocityOnlyComponents": {
    "description": "Velocity-native components with no direct GeoEvent equivalent. Available only in ArcGIS Velocity for ArcGIS Online. These are recommended alternatives when migrating workflows that could benefit from batch analytics, cloud-native messaging, or advanced spatial analysis.",
    "availability": "ArcGIS Velocity for ArcGIS Online",
    "tools": [
      {
        "velocityEquivalent": "aggregate-points",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/aggregate-points.htm",
        "description": "Aggregates point features into bins or polygon areas, computing statistics for each group.",
        "capabilities": [
          "spatial binning",
          "temporal bucketing",
          "statistical aggregation"
        ],
        "keyProperties": [
          "binType",
          "binSize",
          "statistics",
          "timeStepInterval",
          "timeStepAlignment"
        ],
        "geoEventAlternative": "No direct equivalent. Closest is a custom GeoEvent Service using Field Calculator with manual aggregation logic.",
        "recommendWhen": "Migrating workflows that aggregate sensor data by area or time window."
      },
      {
        "velocityEquivalent": "density-calculator",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-density.htm",
        "description": "Calculates kernel density of point features to create a heat map surface.",
        "capabilities": [
          "kernel density estimation",
          "heat map generation"
        ],
        "keyProperties": [
          "searchRadius",
          "areaUnits",
          "classification"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Density analysis typically done outside of real-time processing.",
        "recommendWhen": "Migrating workflows that need to visualize event concentration patterns."
      },
      {
        "velocityEquivalent": "dissolve",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/dissolve-boundaries.htm",
        "description": "Dissolves polygon boundaries based on shared attribute values.",
        "capabilities": [
          "boundary dissolve",
          "multipart geometry",
          "statistical summarization"
        ],
        "keyProperties": [
          "dissolveFields",
          "multiPart",
          "statistics"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Dissolve is a spatial analysis operation not available in real-time processing.",
        "recommendWhen": "Migrating workflows that merge polygon features sharing common attributes."
      },
      {
        "velocityEquivalent": "find-dwell-locations",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/find-dwell-locations.htm",
        "description": "Identifies locations where tracked entities have dwelled for a specified duration within a distance tolerance.",
        "capabilities": [
          "dwell detection",
          "track analysis",
          "stop detection"
        ],
        "keyProperties": [
          "distanceTolerance",
          "timeTolerance",
          "trackIdFields"
        ],
        "geoEventAlternative": "Partial coverage via Incident Detector processor with spatial/temporal conditions.",
        "recommendWhen": "Migrating fleet or asset tracking workflows that need stop/dwell analysis."
      },
      {
        "velocityEquivalent": "find-hot-spots",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/find-hot-spots.htm",
        "description": "Identifies statistically significant spatial clusters using the Getis-Ord Gi* statistic.",
        "capabilities": [
          "hot spot analysis",
          "spatial statistics",
          "temporal bucketing"
        ],
        "keyProperties": [
          "binType",
          "binSize",
          "neighborhoodSize",
          "timeStepInterval"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Statistical spatial analysis not available in real-time processing.",
        "recommendWhen": "Migrating workflows that detect spatial clustering patterns in event data."
      },
      {
        "velocityEquivalent": "find-point-clusters",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/find-point-clusters.htm",
        "description": "Groups point features into clusters using DBSCAN or HDBSCAN algorithms.",
        "capabilities": [
          "DBSCAN clustering",
          "HDBSCAN clustering",
          "noise detection"
        ],
        "keyProperties": [
          "clusterMethod",
          "minPoints",
          "searchDistance"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Clustering is a batch spatial analysis operation.",
        "recommendWhen": "Migrating workflows that group events by spatial proximity."
      },
      {
        "velocityEquivalent": "find-similar-locations",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/find-similar-locations.htm",
        "description": "Finds features most similar to reference features based on specified attributes.",
        "capabilities": [
          "similarity analysis",
          "attribute comparison",
          "ranking"
        ],
        "keyProperties": [
          "analysisFields",
          "numberOfResults",
          "matchMethod"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Similarity analysis is a batch analytical operation.",
        "recommendWhen": "Migrating workflows comparing event locations to reference locations."
      },
      {
        "velocityEquivalent": "forest-based-regression",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/forest-based-classification-and-regression.htm",
        "description": "Performs prediction using a random forest model for classification or regression.",
        "capabilities": [
          "random forest",
          "classification",
          "regression",
          "variable importance"
        ],
        "keyProperties": [
          "explanatoryVariables",
          "dependentVariable",
          "numberOfTrees",
          "predictionType"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Machine learning models require external integration in GeoEvent.",
        "recommendWhen": "Migrating workflows that use predictive modeling on spatial data."
      },
      {
        "velocityEquivalent": "generalized-linear-regression",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/generalized-linear-regression.htm",
        "description": "Performs generalized linear regression to model spatial relationships.",
        "capabilities": [
          "linear regression",
          "spatial modeling",
          "residual analysis"
        ],
        "keyProperties": [
          "explanatoryVariables",
          "dependentVariable",
          "modelType"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Statistical modeling requires external tools in GeoEvent.",
        "recommendWhen": "Migrating workflows that model relationships between spatial variables."
      },
      {
        "velocityEquivalent": "journey-calculator",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/calculate-journeys.htm",
        "description": "Calculates journey statistics for tracked entities including stops, gaps, and movement statistics.",
        "capabilities": [
          "journey analysis",
          "stop detection",
          "gap detection",
          "movement statistics"
        ],
        "keyProperties": [
          "trackIdFields",
          "dwellDistance",
          "dwellDuration",
          "gapDuration",
          "method",
          "output"
        ],
        "geoEventAlternative": "Partial coverage combined with Detect Gaps and Incident Detector processors.",
        "recommendWhen": "Migrating fleet tracking workflows that need comprehensive journey metrics."
      },
      {
        "velocityEquivalent": "merge",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/merge-layers.htm",
        "description": "Combines features from multiple inputs into a single output.",
        "capabilities": [
          "feature merging",
          "schema alignment",
          "multi-source combination"
        ],
        "keyProperties": [],
        "geoEventAlternative": "GeoEvent services can merge streams by routing multiple inputs to one service, but without schema alignment.",
        "recommendWhen": "Migrating workflows that combine data from multiple GeoEvent services.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/merge-layers.html"
      },
      {
        "velocityEquivalent": "network-snapper",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/snap-to-network.htm",
        "description": "Snaps point features to the nearest network edge or junction.",
        "capabilities": [
          "network snapping",
          "road alignment",
          "location correction"
        ],
        "keyProperties": [
          "searchDistance",
          "searchDistanceUnits",
          "networkDataset"
        ],
        "geoEventAlternative": "No GeoEvent equivalent. Network analysis requires separate ArcGIS capabilities.",
        "recommendWhen": "Migrating vehicle tracking workflows that need road-snapped positions.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/analyze/snap-to-network.html"
      },
      {
        "velocityEquivalent": "summarize-attributes",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/summarize-attributes.htm",
        "description": "Computes summary statistics for feature attributes, optionally grouped by fields or time steps.",
        "capabilities": [
          "attribute summarization",
          "group-by statistics",
          "temporal aggregation"
        ],
        "keyProperties": [
          "statistics",
          "groupByFields",
          "timeStepInterval",
          "timeStepAlignment"
        ],
        "geoEventAlternative": "Partial coverage via Field Calculator with COUNT/SUM expressions, but limited grouping.",
        "recommendWhen": "Migrating workflows that compute aggregate statistics from event attributes."
      },
      {
        "velocityEquivalent": "summarize-within",
        "velocityType": "bat-tool",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/analyze/summarize-within.htm",
        "description": "Computes statistics for features within polygon boundaries or bin areas.",
        "capabilities": [
          "spatial summarization",
          "polygon aggregation",
          "bin statistics"
        ],
        "keyProperties": [
          "binType",
          "binSize",
          "statistics",
          "groupByFields"
        ],
        "geoEventAlternative": "No direct equivalent. Geofence-based filtering in GeoEvent provides only binary in/out, not aggregation.",
        "recommendWhen": "Migrating workflows that aggregate event counts or values within geographic areas."
      }
    ],
    "outputs": [
      {
        "velocityEquivalent": "amazon-s3",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/amazon-s3.htm",
        "description": "Writes output features to Amazon S3 as delimited text, JSON, or GeoJSON files.",
        "keyProperties": [
          "objectStore",
          "path",
          "writeMode",
          "access.key",
          "access.secret"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/amazon-s3.html"
      },
      {
        "velocityEquivalent": "aws-iot-output",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/aws-iot.htm",
        "description": "Publishes output features to an AWS IoT Core topic.",
        "keyProperties": [
          "endpoint",
          "topic",
          "accessKeyId",
          "secretAccessKey"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/aws-iot.html"
      },
      {
        "velocityEquivalent": "aws-sns",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/amazon-sns.htm",
        "description": "Publishes output features to an Amazon SNS topic for push notifications.",
        "keyProperties": [
          "topicArn",
          "region",
          "accessKeyId",
          "secretAccessKey"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/amazon-sns.html"
      },
      {
        "velocityEquivalent": "aws-sqs",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/amazon-sqs.htm",
        "description": "Sends output features to an Amazon SQS queue for asynchronous processing.",
        "keyProperties": [
          "queueUrl",
          "region",
          "accessKeyId",
          "secretAccessKey"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/amazon-sqs.html"
      },
      {
        "velocityEquivalent": "azure-blob-store",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/azure-blob-store.htm",
        "description": "Writes output features to Azure Blob Storage as delimited text, JSON, or GeoJSON files.",
        "keyProperties": [
          "connectionString",
          "containerName",
          "path"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/azure-blob-store.html"
      },
      {
        "velocityEquivalent": "azure-event-hub",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/azure-event-hub.htm",
        "description": "Publishes output features to an Azure Event Hub for stream processing.",
        "keyProperties": [
          "endpoint",
          "entityPath",
          "sharedAccessKeyName",
          "sharedAccessKey"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/azure-event-hub.html"
      },
      {
        "velocityEquivalent": "azure-iot-hub",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/azure-iot-hub.htm",
        "description": "Sends output features to an Azure IoT Hub for device communication.",
        "keyProperties": [
          "connectionString",
          "deviceId"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/azure-iot-hub.html"
      },
      {
        "velocityEquivalent": "rabbitmq",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/rabbitmq.htm",
        "description": "Publishes output features to a RabbitMQ exchange for message queuing.",
        "keyProperties": [
          "host",
          "port",
          "exchange",
          "routingKey",
          "username",
          "password"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/rabbitmq.html"
      },
      {
        "velocityEquivalent": "slack",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/slack.htm",
        "description": "Posts output features to a Slack channel via webhook URL.",
        "keyProperties": [
          "url",
          "postBody"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/slack.html"
      },
      {
        "velocityEquivalent": "teams",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/microsoft-teams.htm",
        "description": "Posts output features to a Microsoft Teams channel via webhook URL.",
        "keyProperties": [
          "url",
          "postBody"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/microsoft-teams.html"
      },
      {
        "velocityEquivalent": "trimble-unity-maintain",
        "velocityType": "bat-output",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/disseminate-and-notify/trimble-unity-maintain.htm",
        "description": "Sends output features to Trimble Unity Maintain for asset management.",
        "keyProperties": [
          "url",
          "apiKey"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/disseminate-and-notify/trimble-unity-maintain.html"
      }
    ],
    "sources": [
      {
        "velocityEquivalent": "amazon-s3",
        "velocityType": "bat-source",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/amazon-s3.htm",
        "description": "Reads features from files stored in Amazon S3 buckets. Supports delimited, JSON, GeoJSON, and XML formats.",
        "keyProperties": [
          "objectStore",
          "path",
          "access.key",
          "access.secret",
          "endpoint"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/amazon-s3.html"
      },
      {
        "velocityEquivalent": "azure-blob-store",
        "velocityType": "bat-source",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/azure-blob-storage.htm",
        "description": "Reads features from files stored in Azure Blob Storage. Supports delimited, JSON, GeoJSON, and XML formats.",
        "keyProperties": [
          "connectionString",
          "containerName",
          "path"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/azure-blob-storage.html"
      },
      {
        "velocityEquivalent": "azure-cosmosdb",
        "velocityType": "bat-source",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/azure-cosmos-db.htm",
        "description": "Reads features from an Azure Cosmos DB collection using SQL API queries.",
        "keyProperties": [
          "endpoint",
          "masterKey",
          "database",
          "collection",
          "whereClause"
        ],
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/azure-cosmos-db.html"
      }
    ],
    "feeds": [
      {
        "velocityEquivalent": "adsb-exchange",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/ads-b-exchange.htm",
        "description": "Ingests ADS-B aircraft tracking data from ADS-B Exchange.",
        "recommendWhen": "Alternative for aviation tracking workflows currently using custom TCP/HTTP feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/ads-b-exchange.html"
      },
      {
        "velocityEquivalent": "baron-weather",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/baron-weather.htm",
        "description": "Ingests weather data from DTN (Baron) weather services.",
        "recommendWhen": "Alternative for workflows ingesting weather data via custom HTTP polling.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/baron-weather.html"
      },
      {
        "velocityEquivalent": "dtn-weather",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/dtn-weather.htm",
        "description": "Ingests weather data from DTN weather APIs.",
        "recommendWhen": "Alternative for workflows ingesting DTN weather data via custom HTTP polling.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/dtn-weather.html"
      },
      {
        "velocityEquivalent": "flight-aware-airborne",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/flightaware-airborne-.htm",
        "description": "Ingests airborne flight tracking data from FlightAware Firehose API.",
        "recommendWhen": "Alternative for aviation tracking workflows using custom TCP or HTTP feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/flightaware-airborne-.html"
      },
      {
        "velocityEquivalent": "flight-aware-surface",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/flightaware-surface-.htm",
        "description": "Ingests surface flight tracking data from FlightAware Firehose API.",
        "recommendWhen": "Alternative for airport surface tracking workflows using custom feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/flightaware-surface-.html"
      },
      {
        "velocityEquivalent": "geotab",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/geotab.htm",
        "description": "Ingests fleet vehicle status data from Geotab telematics.",
        "recommendWhen": "Alternative for fleet tracking workflows currently polling Geotab APIs via HTTP.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/geotab.html"
      },
      {
        "velocityEquivalent": "geotab-logrecord",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/geotab.htm",
        "description": "Ingests historical vehicle log records from Geotab telematics.",
        "recommendWhen": "Alternative for fleet log analysis workflows using custom HTTP polling.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/geotab.html"
      },
      {
        "velocityEquivalent": "grpc",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/grpc.htm",
        "description": "Ingests streaming data via gRPC protocol.",
        "recommendWhen": "Alternative for workflows using custom TCP transports for protocol buffer data.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/grpc.html"
      },
      {
        "velocityEquivalent": "gtfs",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/gtfs.htm",
        "description": "Ingests GTFS real-time transit feed data (vehicle positions, trip updates, alerts).",
        "recommendWhen": "Alternative for transit tracking workflows currently polling GTFS-RT feeds via HTTP.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/gtfs.html"
      },
      {
        "velocityEquivalent": "haas",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/haas-alert.htm",
        "description": "Ingests emergency vehicle alert data from HAAS Alert.",
        "recommendWhen": "Alternative for emergency vehicle tracking workflows using custom feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/haas-alert.html"
      },
      {
        "velocityEquivalent": "kinetic",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/cisco-edge-intelligence.htm",
        "description": "Ingests IoT device data from Cisco Kinetic platform.",
        "recommendWhen": "Alternative for IoT device tracking workflows using custom MQTT or HTTP feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/cisco-edge-intelligence.html"
      },
      {
        "velocityEquivalent": "precise-mrm",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/precise-mrm.htm",
        "description": "Ingests mobile device positioning data from Skyhook Precise MRM.",
        "recommendWhen": "Alternative for mobile device tracking workflows using custom feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/precise-mrm.html"
      },
      {
        "velocityEquivalent": "samsara",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/samsara.htm",
        "description": "Ingests fleet vehicle and IoT sensor data from Samsara.",
        "recommendWhen": "Alternative for fleet management workflows currently polling Samsara APIs via HTTP.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/samsara.html"
      },
      {
        "velocityEquivalent": "simulator",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/simulator.htm",
        "description": "Generates simulated feature data for testing and development purposes.",
        "recommendWhen": "Useful for testing migrated analytics before connecting live data sources.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/simulator.html"
      },
      {
        "velocityEquivalent": "vectronics",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/vectronic-aerospace.htm",
        "description": "Ingests wildlife tracking collar data from Vectronics Aerospace.",
        "recommendWhen": "Alternative for wildlife tracking workflows using custom HTTP polling.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/vectronic-aerospace.html"
      },
      {
        "velocityEquivalent": "verizon-reveal-2",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/verizon-connect-reveal.htm",
        "description": "Ingests fleet vehicle tracking data from Verizon Connect Reveal.",
        "recommendWhen": "Alternative for fleet tracking workflows currently polling Verizon APIs via HTTP.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/verizon-connect-reveal.html"
      },
      {
        "velocityEquivalent": "waze",
        "velocityType": "velocity-only-feed",
        "velocityHelpUrl": "https://doc.arcgis.com/en/velocity/ingest/waze.htm",
        "description": "Ingests Waze traffic incident and jam data.",
        "recommendWhen": "Alternative for traffic monitoring workflows using custom HTTP feeds.",
        "velocityHelpUrlEnterprise": "https://doc.esri.com/en/arcgis-velocity/latest/ingest/waze.html"
      }
    ]
  },
  "parameterLabels": {
    "port": "Server Port",
    "host": "Server Host",
    "mode": "Connection Mode",
    "refreshInterval": "Polling Interval (seconds)",
    "customLayerUrl": "Feature Layer URL",
    "queryDefinition": "Query Definition",
    "bufferDistance": "Buffer Distance",
    "unit": "Distance Unit",
    "bufferwkid": "Buffer Spatial Reference",
    "inputGeometryField": "Input Geometry Field",
    "outputGeometryField": "Output Geometry Field",
    "replaceGeometry": "Replace Geometry",
    "MessageSeparator": "Message Separator",
    "AttributeSeparator": "Attribute Separator",
    "inputFileFilter": "File Filter Pattern",
    "inputFolderDataStore": "Input Folder Data Store",
    "outputFolderDataStore": "Output Folder Data Store",
    "outputBaseFileName": "Output Base File Name",
    "outputFileExtension": "Output File Extension",
    "url": "URL",
    "frequency": "Frequency (in seconds)",
    "httpMethod": "HTTP Method",
    "expression": "Expression",
    "existingFieldName": "Existing Field Name",
    "resultDestination": "Result Destination",
    "inputFields": "Input Fields",
    "outputFields": "Output Fields",
    "outwkid": "Output Spatial Reference (WKID)",
    "username": "Username",
    "password": "Password",
    "database": "Database",
    "virtualHost": "Virtual Host",
    "ssl": "Use SSL",
    "exchangeName": "Exchange Name",
    "exchangeType": "Exchange Type",
    "exchangeDurability": "Exchange Durability",
    "exchangeAutoDelete": "Auto-Delete Exchange",
    "queueName": "Queue Name",
    "queueDurability": "Queue Durability",
    "exclusiveQueue": "Exclusive Queue",
    "queueAutoDelete": "Auto-Delete Queue",
    "qualityOfService": "Quality of Service (QoS)",
    "routingKey": "Routing Key",
    "topic": "Topic",
    "qosLevel": "MQTT QoS Level",
    "retainMessages": "Retain Messages",
    "flightAwareHost": "FlightAware Firehose Host",
    "portNumber": "Port Number",
    "feedTypeGroup": "Feed Type Group",
    "airlineFilter": "Airline Filter (ICAO Codes)",
    "airportFilter": "Airport Filter",
    "flightIdentifications": "Flight Identifications",
    "operatorTypeFilter": "Operator Type Filter",
    "envelopeAreaOfInterests": "Envelope Areas of Interest",
    "polygonAreaOfInterests": "Polygon Areas of Interest",
    "densifyFlightPlanPolylines": "Densify Flight Plan Polylines",
    "maxSegmentLength": "Max Segment Length (meters)",
    "curveType": "Curve Type",
    "useCompression": "Use Compression",
    "strictUnblocking": "Strict Unblocking",
    "rateLimit": "Rate Limit (seconds)",
    "rateLimitAirborne": "Airborne Rate Limit",
    "rateLimitSurface": "Surface Rate Limit",
    "timeout": "Timeout (seconds)",
    "workOrderTemplateIds": "Work Order Template IDs",
    "workOrderTemplate": "Work Order Template",
    "dynamicWorkOrder": "Dynamic Work Order",
    "workOrderTemplateIDField": "Work Order Template ID Field",
    "serverPort": "Server Port",
    "connectionTimeout": "Connection Timeout (seconds)",
    "handshakeText": "Handshake Text",
    "filterMMSI": "MMSI Filter",
    "filterMessageTypeID": "Message Type ID Filter",
    "filterIMO": "IMO Filter",
    "minimumLatitude": "Minimum Latitude",
    "minimumLongitude": "Minimum Longitude",
    "maximumLatitude": "Maximum Latitude",
    "maximumLongitude": "Maximum Longitude",
    "dataTypes": "Data Types",
    "urlParameters": "URL Parameters",
    "sourceURL": "Source URL",
    "headers": "HTTP Headers",
    "isTextFormat": "Parse as Text",
    "timeUnit": "Time Unit",
    "pollingFrequency": "Polling Frequency",
    "useScheduledTime": "Use Scheduled Time",
    "startTime": "Start Time",
    "repeatInterval": "Repeat Interval",
    "useEndTime": "Use End Time",
    "repeatCount": "Repeat Count",
    "endTime": "End Time",
    "acceptableMimeTypes": "Acceptable MIME Types",
    "useUrlProxy": "Use URL Proxy",
    "parameters": "URL Parameters",
    "headerParameters": "Header Parameters",
    "useLongPolling": "Use Long Polling",
    "httpTimeout": "HTTP Timeout (seconds)",
    "customerName": "Customer Name",
    "downloadMetadata": "Download Metadata",
    "metaDataUpdateInterval": "Metadata Update Interval (minutes)",
    "topicName": "Topic Name",
    "providerURL": "Provider URL",
    "jmsDestinationType": "JMS Destination Type",
    "jmsDestinationName": "JMS Destination Name",
    "jsonObjectName": "JSON Object Name",
    "createGeoEventDefinition": "Create GeoEvent Definition",
    "geoEventDefinitionName": "GeoEvent Definition Name",
    "expectedDateFormat": "Expected Date Format",
    "constructGeometryFromFields": "Construct Geometry from Fields",
    "xGeometryField": "X Geometry Field",
    "yGeometryField": "Y Geometry Field",
    "zGeometryField": "Z Geometry Field",
    "defaultSpatialReference": "Default Spatial Reference",
    "learningMode": "Learning Mode",
    "asGeoJSON": "Parse as GeoJSON",
    "distanceUnit": "Distance Unit",
    "geometryType": "Geometry Type",
    "countNotificationMode": "Notification Mode",
    "reportInterval": "Report Interval (seconds)",
    "automaticResetCache": "Automatic Reset Cache",
    "resetCacheAt": "Reset Cache At",
    "clearInMemoryCache": "Clear In-Memory Cache",
    "predictiveTimespan": "Predictive Timespan (seconds)",
    "resultingGeoEventDefinitionName": "Resulting GeoEvent Definition Name",
    "eventGeometryField": "Event Geometry Field",
    "partiesGeofencesCategory": "Parties Geofences Category",
    "rendezvoussGeofencesCategory": "Rendezvous Geofences Category",
    "rendezvoussProximity": "Rendezvous Proximity",
    "rendezvoussSpatialReference": "Rendezvous Spatial Reference",
    "expiryTime": "Expiry Time (seconds)",
    "expirationCheckRate": "Expiration Check Rate (seconds)",
    "delayTime": "Delay Time",
    "delayTimeUnit": "Delay Time Unit",
    "delayTimeField": "Delay Time Field",
    "enforceDelayThreshold": "Enforce Delay Threshold",
    "allowDuplicates": "Allow Duplicates",
    "useTrackId": "Use Track ID",
    "useLocation": "Use Location",
    "clearCache": "Clear Cache",
    "searchRadius": "Search Radius",
    "useEventCount": "Use Event Count",
    "eventWindowSize": "Event Window Size",
    "idleNotificationMode": "Idle Notification Mode",
    "maximumTimeAllowedForIdling": "Maximum Time Allowed for Idling (seconds)",
    "tolerance": "Tolerance",
    "keepFields": "Keep Fields",
    "outputGeoEventDefinitionSuffixName": "Output GeoEvent Definition Suffix",
    "accumulateIdleDuration": "Accumulate Idle Duration",
    "reportIdleDurationWhileNotIdle": "Report Idle Duration While Not Idle",
    "maxRowCount": "Maximum Row Count",
    "geometryFieldName": "Geometry Field Name",
    "mgrsField": "MGRS Field",
    "newGeoEventDefinitionName": "New GeoEvent Definition Name",
    "accuracy": "Accuracy (Precision Level)",
    "overwriteGeometry": "Overwrite Geometry",
    "newGeometryFieldName": "New Geometry Field Name",
    "returnBoundingBox": "Return Bounding Box",
    "fieldToSplit": "Field to Split",
    "fieldSplitter": "Field Splitter Delimiter",
    "hostName": "Host Name",
    "databaseName": "Database Name",
    "collectionName": "Collection Name",
    "filePath": "File Path",
    "baseFileName": "Base File Name",
    "userName": "User Name",
    "consumerKey": "Consumer Key",
    "consumerSecret": "Consumer Secret",
    "accessToken": "Access Token",
    "accessTokenSecret": "Access Token Secret",
    "follow": "Follow IDs",
    "track": "Track Keywords",
    "locations": "Locations Filter",
    "count": "Tweet Count",
    "multicastGroup": "Multicast Group",
    "eventSeparator": "Event Separator",
    "fieldSeparator": "Field Separator",
    "attributeSeparatorToBeReplaced": "Attribute Separator Pattern (Regex)",
    "createUnrecognizedEventDefinitions": "Create Unrecognized Event Definitions",
    "incomingDataContainsGeoEventDefinition": "Incoming Data Contains GeoEvent Definition",
    "languageForNumberFormatting": "Language for Number Formatting",
    "writeNullValues": "Write Null Values",
    "writeEmptyStringValues": "Write Empty String Values",
    "generateFlatJson": "Generate Flat JSON",
    "formattedJson": "Formatted JSON",
    "deleteOldFeatures": "Delete Old Features",
    "maximumFeaturesPerTransaction": "Maximum Features Per Transaction",
    "arcgisServerConnection": "ArcGIS Server Connection",
    "folder": "Folder",
    "serviceName": "Service Name",
    "layer": "Layer",
    "referenceToLayerType": "Reference to Layer Type",
    "uniqueFeatureIdentifierField": "Unique Feature Identifier Field",
    "updateInterval": "Update Interval (seconds)",
    "geoMessageType": "GeoMessage Type",
    "bearing": "Bearing Field",
    "bootstrapServers": "Bootstrap Servers",
    "clientConnectionTimeout": "Client Connection Timeout (seconds)",
    "clientParameters": "Client URL Parameters",
    "clientURL": "Client URL",
    "consumerGroupId": "Consumer Group ID",
    "dataJoinFieldName": "Data Join Field Name",
    "destinationSource": "Destination Source",
    "eventJoinFieldName": "Event Join Field Name",
    "fields": "Fields",
    "geofence": "Geofence Filter",
    "geometryField": "Geometry Field",
    "incidentName": "Incident Name",
    "incidentType": "Incident Type",
    "inputBatchFlushIntervalInMS": "Batch Flush Interval (ms)",
    "inputDeleteFiles": "Delete Files After Processing",
    "interval": "Interval",
    "keepSourceFields": "Keep Source Fields",
    "originSource": "Origin Source",
    "outputDirectory": "Output Directory",
    "outputFileFooter": "File Footer",
    "outputFileFrequency": "File Rotation Frequency",
    "outputFileHeader": "File Header",
    "outputFileSizeLimitMethod": "File Size Limit Method",
    "outputFileSizeLimitValue": "File Size Limit (KB)",
    "postContentType": "POST Content Type",
    "range": "Range",
    "service": "Service",
    "spatialOperator": "Spatial Operator",
    "subject": "Subject",
    "to": "To Recipients",
    "xField": "X Field",
    "yField": "Y Field",
    "body": "Message Body",
    "closingCondition": "Closing Condition",
    "createBearingSegment": "Create Bearing Segment",
    "dataRetention": "Data Retention",
    "enrichmentFields": "Enrichment Fields",
    "eventFieldName": "Event Field Name",
    "fieldsToRemove": "Fields to Remove",
    "joinFieldName": "Join Field Name",
    "joinGEDName": "Join GeoEvent Definition Name",
    "maxEventCount": "Maximum Event Count",
    "maxFeatures": "Maximum Features",
    "maxFeaturesPerTransaction": "Maximum Features Per Transaction",
    "maxGapDuration": "Maximum Gap Duration",
    "message": "Message",
    "notificationType": "Notification Type",
    "openingCondition": "Opening Condition",
    "outputBearingField": "Output Bearing Field",
    "outputDefinitionName": "Output GeoEvent Definition Name",
    "overlayGeometryField": "Overlay Geometry Field",
    "overlayType": "Overlay Type",
    "phoneNumber": "Phone Number",
    "rangeUnit": "Range Unit",
    "regexExpression": "Regular Expression",
    "serviceLayerUrl": "Service Layer URL",
    "severity": "Severity",
    "smtpHost": "SMTP Host",
    "smtpPort": "SMTP Port",
    "sourceField": "Source Field",
    "spatialRelationship": "Spatial Relationship",
    "streamServiceUrl": "Stream Service URL",
    "targetField": "Target Field",
    "timeRange": "Time Range",
    "timeWindow": "Time Window",
    "trackIdField": "Track ID Field",
    "traversal": "Traversal",
    "uniqueFeatureIdentifier": "Unique Feature Identifier",
    "zField": "Z Field"
  }
}
